export default {
  welcomeToCompass: "Welcome to",
  portalName: "Compass",
  emailAddress: "Email Address",
  username: "Username",
  user: "User",
  password: "Password",
  login: "Login",
  continue: "Continue",
  register: "Register",
  registerNow: "Register Now",
  noAccount: "Don't have an account?",
  done: "Done",
  next: "Next",
  back: "Back",
  error: "Error",
  redirectError: "Unfortunately the link to log into Compass is invalid or has expired. Please try again.",
  unknownError: "Unfortunately an unknown error has occurred",
  backButton: "Back",
  confirmationButton: {
    title: "Are you sure?",
    cancelButtonText: "Cancel",
    confirmationButtonText: "Confirm",
  },
  dataUsageBar: {
    left: "left",
    usageLimit: "Usage limit",
    planUsage: "Plan usage",
    dataBooster: "Data booster",
    total: "Total",
    overage: "Overage",
    percentUsed: "{pct}% used",
  },
  yes: "Yes",
  no: "No",
  trackRegister: "Want to track and access all your tickets?",
  accountCreateMsg: `Account details will be verified by the Speedcast team and you will receive an email when your account has been created.`,
  accountEmailDisclaimer: `Please note that only corporate or business email addresses will be approved for access to Compass. Personal email domains (e.g., Gmail, Yahoo, etc.) will not be accepted.`,
  forgotPassword: "Forgot Password?",
  weCanEmailYouLinkToResetYourPassword: "We will email you a link to reset your password",
  cancel: "Cancel",
  close: "Close",
  delete: "Delete",
  confirm: "Confirm",
  moreInfo: "More Info",
  backToDetails: "Back to alert details",
  showAll: "Show All",
  passwordResetLinkExpired: "No password reset request found or link has expired",
  returnToLogin: "Return to Login",
  redirectingToLoginIn: "Redirecting to Login in",
  resetPassword: "Reset Password",
  enterNewPassword: "Enter new password",
  ifAnAccountExists: "You will receive a link to reset your password if an account exists for email: ",
  noPasswordResetFound: "No password reset request found or requested expired",
  // failed login messages
  "Session expired": "Session expired",
  "Access denied": "Access Denied",
  "Token not found": "Token not found",
  "Invalid Login": "Invalid Login",
  // register
  createAccount: "Create account",
  businessEmail: "Business Email",
  businessPhone: "Business Phone",
  mobilePhone: "Mobile Phone",
  iAgreeToThe: "I agree to the", // privacy policy and terms and conditions, which are links and translated below
  and: "and", // and for the agreement
  privacyPolicyUrl: "https://www.speedcast.com/privacy-policy/",
  termsAndConditionsUrl: "https://www.speedcast.com/terms-and-conditions/",
  registerUserRequestForAccess:
    'We\'ve received your request for access.  Please allow 24-48 hours for review and approval.  You will receive an email once approved. For immediate assistance, please create a "Guest Support Ticket" or contact us at +1 (832) 668 2775.',
  backToLogin: "Back to Login",
  // guest ticket
  createGuestTicket: "Create Guest Support Ticket",
  phone: "Phone",
  siteVessel: "Site/Vessel",
  briefDescription: "Brief description of the issue",
  company: "Company",
  isRequired: " is required",
  ticketSubmitted: "Ticket has been submitted.",
  // Menu Bar
  mapView: "Map View",
  fleet: "Fleet",
  performance: "Performance",
  starlinkPoolsUsage: {
    name: "Starlink Pools Usage",
    selectPool: "Select Pool",
  },
  reports: "Reports",
  servicesOverview: "Services Overview",
  slaReports: "SLA Reports",
  ipslasOverview: "IPSLAs Overview",
  starlinkOverview: "Starlink Overview",
  support: "Support",
  myAccount: "My Account",
  speedcastSettings: "Speedcast Settings",
  speedcastTeam: "Speedcast Team",
  speedcastDotCom: "Speedcast.com",
  speedcastDotComDescription: "Learn more about Speedcast's global solutions.",
  speedcastDotComUrl: "https://www.speedcast.com",
  sigmaPortal: "SIGMA Portal",
  sigmaPortalDescription: "Visit the SIGMA Portal to manage your SIGMA devices",
  sigmaPortalUrl: "https://portal.sigma-edge.com",
  compassApiDocUrl: "https://api.compass.speedcast.com/api-docs/",
  userGuideUrl: "/Compass_Portal_Comprehensive_User_Guide.pdf",
  starlinkGuideUrl: "/Starlink_Self_Activation_and_Plan_Change_QSG.pdf",
  permissionsDocUrl: "/Speedcast_Compass-User_Permission_and_Roles_Definitions-Customer_Letter.pdf",
  userPermissionRolesFile: "/Speedcast_Compass-User_Permission_and_Roles_Definitions-Customer_Letter.pdf",
  cookiePolicyUrl: "https://www.speedcast.com/cookie-policy/",
  subscribeToNewsletterUrl: "https://www.speedcast.com/sign-up-for-our-newsletter/",
  termsAndConditions: "Terms & Conditions",
  termsAndConditionsDescription: "Read Speedcast’s terms and conditions.",
  starlinkActivationTerms:
    "Submitted as a Customer Change Notice, activating the Starlink Service Plan to the Starlink Kit(s) listed above under the terms of the applicable Service Order.",
  starlinkEditServicesTerms:
    "Submitted as a Customer Change Notice, instructing Speedcast to make the requested changes to the Starlink Service Plans in use with the Starlink Kit(s) listed above, under the terms of the applicable Service Order.",
  permission: {
    denied: "You do not have permission to view this page. Please contact your administrator.",
    redirecting: "You will be redirected in {count} seconds...",
  },
  viewEdit: "View / Edit",
  privacyPolicy: "Privacy Policy",
  privacyPolicyDescription: "Understand how we handle personal data.",
  cookiePolicy: "Cookie Policy",
  cookiePolicyDescription: "Review how we use cookies across our website.",
  subscribeToNewsletter: "Subscribe to Newsletter",
  subscribeToNewsletterDescription: "Stay up to date with Speedcast news and events.",
  footerCopyright: "Speedcast {year}. All Rights Reserved.",
  userGuide: "User Guide",
  comprehensiveUserGuide: "Comprehensive User Guide",
  userGuideDescription: "Detailed instructions on Compass Portal features.",
  starlinkGuide: "Starlink Management Guide",
  starlinkGuideDescription: "Step-by-step instructions for managing your Starlink services with Compass.",
  compassApiDoc: "API Documentation",
  compassApiDocDescription: "Compass API description document.",
  quickStartVideo: "Quick Start Video",
  quickStartVideoDescription: "An overview of basic Compass Portal usage.",
  welcomeVideo: "Welcome Video",
  welcomeVideoDescription: "A short welcome and portal overview.",
  compassPermissionVideo: "Compass Permission Video",
  compassPermissionVideoDescription: "How to manage user roles and permissions in Compass.",
  permissionsDoc: "Permissions Documentation",
  permissionsDocDescription: "Reference for user permissions in the Compass Portal.",
  loadingMoreResources: "Loading more resources",
  resources: "Resources",
  logout: "Logout",
  noServicesFoundForThisCompany: "No Services found for this company",
  noUsersFoundForThisCompany: "No users found for this company",
  viewModem: "View modem",
  manageMyServices: "Manage My Services",
  manageMyServicesAllSelected: "Please select a company to manage your services.",
  permissionsAllSelected: "Please select a company to manage your user permissions.",
  permissionsChangeLogAllSelected: "Please select a company to view your user change logs.",
  alertsAllSelected: "Please select a company to manage your Starlink alerts.",
  adminRoleChangeLog: {
    title: "Role Changelog",
    titleWithCompany: "{company} Role Changelog",
    noChangesFound: "No changes found.",
    loadError: "Something went wrong loading role changes.",
    changedBy: "Changed by",
  },
  pendingActions: "Pending Actions",
  actions: "Actions",
  noActions: "No Actions",
  editServices: "Overview of Services",
  editUserAlerts: "Alerts",
  starlinkAlertsMgmt: "Starlink Alerts",
  manageAlerts: "Manage Alerts",
  editUserPermission: "Permissions",
  compassApi: "Compass API",
  compassApiSplashTitle: "Compass API Management",
  compassApiSplashText:
    "The following pages allow you to subscribe to Compass APIs, manage your API subscriptions, and view your connection details. By using Compass, you are notifying Speedcast of the changes you require, and Speedcast will invoice you under the terms of your contract accordingly. Please ensure that the Personnel using Compass are authorized to make changes on behalf of your company and to send and receive notices in relation to the Services under the contract.",
  catalogApis: "API Subscriptions",
  compassApiSubscriptions: "Subscriptions",
  compassApiLoadFailure: "Could not retrieve subscription information",
  compassApiRetry: "Retry",
  compassApiName: "Name",
  compassApiDescription: "Description",
  compassApiApis: "APIs",
  compassApiApiName: "API Name",
  compassApiUrl: "URL",
  compassApiViewConnectionDetails: "View Connection Details",
  compassApiViewSubscriptionDetails: "View Subscription Details",
  compassApiDeleteSubscription: "Delete this Subscription",
  compassApiRemoveApisBeforeDelete: "Remove all APIs from this Subscription before deleting it",
  compassApiRemoveApiFromSubscription: "Remove {api} from {name}",
  compassApiDeleteSubscriptionFailure: "Could not delete subscription",
  compassApiRemoveApiFailure: "Could not remove API",
  compassApiFaqTitle: "Compass API FAQ",
  compassApiAgree: "Agree",
  compassApiGettingAccessToken: "Getting an access token",
  compassApiAccessTokenInstructions:
    "You can request an access token using the OAuth 2.0 client credentials grant type.",
  compassApiClientSecretInstructions:
    "Note: remember to adapt the request to use the client secret you copied during the initial subscription creation.",
  compassApiAccessTokenResult:
    "If the request is valid, the authorization server will issue an access token to make authorized calls to the APIs.",
  compassApiCallApis: "Call your APIs",
  compassApiAuthorizationInstructions:
    "Use your access_token in your request via the Authorization HTTP header to obtain authorized access to the APIs.",
  compassApiEndpointPathInstructions: "Note: remember to append any path to the url the endpoints offers.",
  compassApiNoSubscriptions: "No Subscribed APIs",
  compassApiNoSubscriptionsHint: 'Click on the "Subscribe to APIs" button above to start',
  compassApiDeleteTitle: "Delete Subscription",
  compassApiDeleteConfirm: 'Are you sure you want to delete "{name}"?',
  compassApiDeleteBtn: "Delete",
  compassApiDeleteSuccessTitle: "Subscription Deleted",
  compassApiDeleteSuccessMessage: '"{name}" has been deleted.',
  deleting: "Deleting...",
  compassApiSubscribeBtn: "Subscribe to APIs",
  compassApiLoadingApis: "Loading APIs...",
  compassApiSubscriptionCreated: "API Subscription Created!",
  compassApiAppId: "App ID",
  compassApiSecret: "Secret",
  compassApiClientId: "Client ID",
  compassApiClientSecret: "Client Secret",
  compassApiSecretWarning: "Save your Client ID and Client Secret now — they will not be shown again.",
  close: "Close",
  copyToClipboard: "Copy to clipboard",
  copied: "Copied!",
  compassApiConnectionDetails: "Connection Details",
  compassApiTokenUrl: "Token URL",
  compassApiCurlCommand: "cURL",
  compassApiPowerShellCommand: "PowerShell",
  compassApiGatewayUrl: "Gateway URL",
  compassApiApiUrls: "API URLs",
  compassApiSubscriptionDetails: "Subscription Details",
  compassApiSubscribedApis: "Subscribed APIs",
  compassApiEditSubscription: "Edit",
  compassApiSaveSubscription: "Save",
  compassApiSubscriptionUpdated: "Subscription updated.",
  compassApiDuplicateSubscriptionName: "A subscription with this name already exists.",
  compassApiUpdateSubscriptionFailure: "Could not update subscription.",
  compassApiCreateSubscriptionFailure: "Could not create subscription.",
  compassApiManageApis: "Manage APIs",
  compassApiAddApi: "Add API",
  compassApiAddApis: "Add APIs",
  compassApiAddApiSuccessTitle: "API Added",
  compassApiAddApiSuccessMessage: "{api} has been added to this subscription.",
  compassApiAddApisSuccessTitle: "APIs Added",
  compassApiAddApisSuccessMessage: "{apis} have been added to this subscription.",
  compassApiAddApisPartialFailure: "Some APIs could not be added to the subscription.",
  compassApiAddApisFailure: "Could not add APIs to the subscription.",
  compassApiRemoveApi: "Remove API",
  compassApiRemoveApis: "Remove APIs",
  compassApiRemoveApiBtn: "Remove",
  compassApiRemoveApiConfirm: "Remove {api} from this subscription?",
  compassApiRemoveApisConfirm: "Select the provider APIs to remove from this subscription.",
  compassApiDefaultApiRemoveWarning: "The Compass API is included automatically and cannot be removed.",
  compassApiRemoveApiSuccessTitle: "API Removed",
  compassApiRemoveApiSuccessMessage: "{api} has been removed from this subscription.",
  compassApiRemoveApisSuccessTitle: "APIs Removed",
  compassApiRemoveApisSuccessMessage: "{apis} have been removed from this subscription.",
  compassApiRemoveApisPartialFailure: "Some APIs could not be removed from the subscription.",
  compassApiRemoveApisFailure: "Could not remove APIs from the subscription.",
  compassApiSubscriptionName: "API Subscription Name",
  compassApiSubscriptionDescription: "API Subscription Description",
  compassApiSelectApi: "API",
  compassApiSelectApis: "Available APIs",
  compassApiSelectCompany: "Company",
  compassApiViewApisBtn: "View Available APIs",
  compassApiDialogTitle: "Available APIs",
  compassApiDialogIntro: "Here's a quick look at what each Compass API can do for you.",
  // the link text is a separate key so it can sit inline at the end of the sentence
  compassApiDialogSpecPrompt: "Looking for the technical specification? See the full",
  compassApiDialogSpecLink: "Swagger Reference",
  compassApiNameCol: "API",
  compassApiDescriptionCol: "What It Does",
  compassApiDocsCol: "Reference",
  compassApiViewDocsBtn: "View API Reference",
  compassApiViewDocsSection: "View {api} reference",
  compassApiDocsLinkLabel: "Swagger",
  compassApiFaqContent: {
    whatIsApi: {
      question: "What is the Compass API?",
      answer:
        "The Compass API lets you integrate Compass platform data and actions directly into your own systems, using the same subscription and service management capabilities available in the Compass portal.",
    },
    gettingStarted: {
      question: "How do I get access to an API?",
      answer:
        'Click "Subscribe to APIs", give your subscription a name and description, and choose the APIs you want. All available APIs are selected by default, and the Compass API is included automatically. Service management APIs can be included too, but requests to them are authorized against the Compass permissions of the user who created the subscription. This creates a set of credentials you can use to authenticate.',
    },
    credentials: {
      question: "Where do I find my Client ID and Client Secret?",
      answer:
        "They're shown once, right after you create a subscription. Copy and store them somewhere safe — Compass will not display the Client Secret again.",
    },
    authentication: {
      question: "How do I authenticate my requests?",
      answer:
        "The Compass API uses the OAuth 2.0 client credentials grant. Exchange your Client ID and Client Secret for an access token at the token URL, then send that token in the Authorization header of your API calls. Open Connection Details on a subscription for a ready-to-use example.",
    },
    manageApis: {
      question: "Can I subscribe to more than one API?",
      answer:
        'Yes. Choose the APIs you want when creating the subscription, then use "Manage APIs" to add or remove APIs later. The Compass API is included automatically and cannot be removed.',
    },
    changeSecret: {
      question: "What if my Client Secret is compromised or lost?",
      answer:
        "Client Secrets cannot be changed or re-displayed. Create a new subscription to get a new Client ID and Client Secret, update your systems to use the new credentials, then remove the APIs from the old subscription and delete it. A subscription can only be deleted once all of its APIs have been removed.",
    },
  },
  emailRequired: "Email Required",
  savedSuccessfully: "Saved Successfully",
  confirmDeleteAlert: "Are you sure you want to delete the alert?",
  openLink: "Open Link",
  notAvailableYet: "Not available yet",
  comingSoon: "Coming Soon",
  starlinkModemView: {
    dataUsageCurrentMonth: "Data usage for current month.",
    dataUsageDisclaimer: `Data usage tracking is not immediate and may be delayed by 24 hours or more.   Counting shown is for informational purposes only and final overages reflected in monthly invoice are accurate.`,
    priority: {
      optedIn: "Opted In",
      optedInTooltip:
        "Kit will continue to receive additional Priority Data  after exceeding included data. This will incur additional charges. Visit ‘Manage My Kit’ to change the status",
      optedOut: "Opted Out",
      optedOutTooltip:
        "Opt in to additional Priority Data to maintain network priority after exceeding included data. This will incur additional charges. Visit ‘Manage My Kit’ to change the status",
    },
  },
  noDataForPeriod: "No data for this time period",
  datePickerHelper: "You can use the date picker on the top to select a different time period",
  // Starlink
  starlink: {
    continueInBackground: "Continue in the background",
    errorChangeKitStatus: "Could not change kit {kitId}",
    errorDeactivateKit: "Could not deactivate kit {kitId}",
    errorSuspendKit: "Could not suspend kit {kitId}",
    errorResumeKit: "Could not resume kit {kitId}",
    errorActivateKit: "Could not activate kit {kitId}",
    updateMsg: "Kit {kitId} has been updated",
    menuManagement: "Starlink",
    actionButtonSelect: {
      label: "No Change",
      btnAction: "Apply",
      deactivate: "Deactivate",
      scheduleDeactivate: "Schedule Deactivation",
      suspend: "Suspend",
      resume: "Resume",
      activate: "Activate",
    },
    completed: "Completed",
    servicePlanUsage: "Service Plan Usage",
    monthlyUsageTooltip: "Usage by each kit on the plan per day",
    sharedPlan: "Shared Plan",
    dualPlan: "Dual Plan",
    sharedServiceLine: "Shared service line - individual kit usage is not available",
    kitUsage: "Kit Usage",
    fleetUsage: "Starlink Fleet Usage",
    planUsage: "Plan Usage",
    softwareVersion: "Software Version",
    lastSignal: "Last Signal Reading",
    planAllowance: "Plan Allowance",
    usageLimit: "Usage Limit",
    totalAllowance: "Total Allowance",
    percentUsed: "% of Limit",
    sortByLabel: "Sort by",
    sortUsage: "Usage",
    sortUsagePercent: "Usage % of Limit",
    sortUsageLimit: "Usage Limit",
    sortOverage: "Overage",
    sortServiceName: "Service Name",
    sortKitId: "Kit Id",
    sortAscending: "Ascending",
    sortDescending: "Descending",
    priorityDataUsage: "Priority Data Usage",
    priorityUsed: "Priority data used",
    dataLeft: "left",
    planEndsInDays: "Plan ends today | Plan ends in {n} day | Plan ends in {n} days",
    currentPlanPeriod: "Current plan · {start} – {end}",
    planPeriod: "{start} – {end}",
    fleetUsageHelpIntro:
      "Each bar shows the plan usage breakdown for a kit or shared service line for the selected period.",
    fleetUsageHelpPriority: "Priority (light blue): priority data used within the plan usage limit.",
    fleetUsageHelpBooster:
      "Data Boosters (green): priority data used above the plan usage limit but within the purchased Data Boosters.",
    fleetUsageHelpStandard: "Standard (dark blue/black): standard data used.",
    fleetUsageHelpRemaining: "Remaining (grey): unused portion of the plan usage limit plus Data Boosters.",
    fleetUsageHelpOverage:
      "Overage (yellow): priority data used above the plan usage limit plus any purchased Data Boosters.",
    fleetUsageHelpOptIn:
      "The opt in/out setting does not change the bar colors. If a kit was opted out for part of the period and then opted in, the bar still only shows total usage versus the plan limit. The tooltip's Priority Opt In line reflects the current status only, not the history of changes.",
    fleetUsageHelp:
      "Overage is the amount of priority data used beyond the plan’s usage limit plus any purchased Data Boosters. Data usage tracking is not immediate and may be delayed by 24 hours or more. Counting shown is for informational purposes only and final overages reflected in monthly invoice are accurate.",
    noFleetUsage: "No Starlink usage found for this company",
    noFleetUsageSearch: "No matches for '{q}'",
    priority: "Priority",
    standard: "Standard",
    remaining: "Remaining",
    overage: "Overage",
    selectCompanyForFleetUsage: "Please select a company to view fleet usage",
    alertRepeatsInfo: `If checked, the alert will be triggered every time the threshold is reached`,
    alertEmailPlaceholder: "Alerts will be sent to this email(s)",
    emailMax: "Maximum {count} emails allowed",
    emailHint: "Add at least one email and up to {count} emails",
    additionalEmailHint: "Add up to {count} additional email addresses",
    viewByService: "Services",
    viewByPool: "By Pool",
    viewByAlert: "Alerts",
    kitSerialNumber: "Kit Serial Number",
    servicesCount: "Services",
    servicesCountWord: "Service | Services",
    poolsCountWord: "Pool | Pools",
    threshold: "Threshold",
    repeatEvery: "Repeat every",
    selectedCount: "{count} selected",
    batchCreateTitle: "Create alert for selected services",
    batchEditTitle: "Edit alert",
    batchCreateSubmit: "Create Alert",
    batchCreateScope: "This alert will be created on {services} services.",
    batchCreateTitleShort: "Add alert to services",
    batchCreateTitleShortPool: "Add alert to pools",
    batchScopeNames: "Applies to 1 service | Applies to {count} services",
    batchScopeNamesPool: "Applies to 1 pool | Applies to {count} pools",
    batchScopeMore: "+{count} more",
    batchPercentHint: "Percent of each service's own plan.",
    batchPercentHintPool: "Percent of each pool's own allowance.",
    batchSeparateAlerts:
      "Each service gets its own alert. The threshold is measured per service, not added up across the selection.",
    batchSeparateAlertsPool:
      "Each pool gets one alert that covers every kit on it. The threshold is measured against the pool's own allowance, not per kit.",
    batchEmailLabel: "Email · required for a batch",
    batchEmailBatchHint: "Some services have no account address, so add at least one here.",
    batchPreflightTitle: "{skipped} of {total} will be skipped",
    batchPreflightBody: "Being checked as you change the form.",
    batchPreflightShow: "Show the {count} service | Show the {count} services",
    batchPreflightShowPool: "Show the {count} pool | Show the {count} pools",
    batchPreflightDrop: "Remove them from the selection",
    batchPreflightAtCapacity: "already at {max}/{max}",
    batchPreflightDuplicate: "already has this alert",
    batchPreflightOverLimit: "{plan} stops at {limit} GB",
    batchPreflightNoAllowance: "{plan} has no data allowance to measure",
    batchCreateSubmitCount: "Create on 1 service | Create on {count} services",
    batchCreateSubmitCountPool: "Create on 1 pool | Create on {count} pools",
    batchEditScope: "Editing {alerts} across {services}",
    batchThresholdHint: "Between 1 and {limit} GB, the largest plan in the selection",
    batchThresholdHintPool: "Between 1 and {limit} GB, the largest pool allowance in the selection",
    // editing writes to every service picked, so the cap is whichever of them has the least to spend
    batchThresholdHintEdit: "Between 1 and {limit} GB, the smallest plan in the selection",
    batchThresholdHintEditPool: "Between 1 and {limit} GB, the smallest pool allowance in the selection",
    batchChunkNotice: "Large selections are sent in batches of {size}.",
    batchRunsInDock: "This closes when the run starts. Progress shows in the bottom corner.",
    bulkJobsTitle: "Bulk updates",
    bulkJobsRunning: "{count} running",
    bulkJobsProgress: "{done} of {total}",
    bulkJobsCounts: "{created} created, {skipped} skipped, {failed} failed",
    bulkJobsCountsUpdated: "{created} updated, {failed} failed",
    bulkJobsAllCreated: "{count} alerts created",
    bulkJobsAllUpdated: "{count} alerts updated",
    bulkJobsKeepOpen: "Keep this browser tab open. Refreshing or closing it stops the run partway through.",
    bulkJobsOpenPage: "Open the page this run started from",
    bulkJobsClearFinished: "Clear finished",
    bulkJobsDismiss: "Dismiss",
    bulkJobsCollapse: "Collapse",
    bulkJobsExpand: "Expand",
    bulkJobsView: "View results",
    bulkJobCreating: "Creating {count} alert | Creating {count} alerts",
    bulkJobUpdating: "Updating {count} alert | Updating {count} alerts",
    batchResultTitle: "Result",
    batchResultCounts: "{done} done, {skipped} skipped, {failed} failed",
    batchSkipDuplicate: "already has this alert",
    batchSkipOverLimit: "threshold is above the plan limit",
    batchSkipNoAllowance: "plan has no data allowance to measure",
    duplicateAlert: "This service already has an alert with the same type, threshold and repeat.",
    searchPlaceholder: "Find by service, kit or email",
    createGroupAlert: "Add Alert to Services",
    createGroupAlertPools: "Add Alert to Pools",
    selectServicesHint: "Select services to enable",
    selectPoolsHint: "Select pools, or the kits under one, to enable",
    createGroupAlertOn: "Add Alert to {count} Service | Add Alert to {count} Services",
    createGroupAlertOnPools: "Add Alert to {count} Pool | Add Alert to {count} Pools",
    createGroupAlertHelpLabel: "About adding alerts in bulk",
    createGroupAlertHelp:
      "Tick one or more services (or Select All) and set the alert once instead of opening each service. Every service gets its own separate alert. Up to {max} alerts per service.",
    createGroupAlertHelpPools:
      "Tick one or more pools (or the kits under one) and set the alert once instead of opening each. A pool alert watches the pool's own limit and leaves the kits under it alone. Up to {max} alerts per pool.",
    preflightSkipCount:
      "{skipped} of {total} is at {max}/{max} and will be skipped | {skipped} of {total} are at {max}/{max} and will be skipped",
    noRepeat: "no repeat",
    keptOldValue: "kept old value",
    noAlertsAnywhere: "No alerts to show",
    createAlertForAll: "Add an alert to all {scope}",
    leavesGroupNote:
      "The threshold was {was}. Saving here moves this service out of the {count}-service alert into one of its own. The other {others} doesn't change. | The threshold was {was}. Saving here moves this service out of the {count}-service alert into one of its own. The other {others} don't change.",
    overLimitDropNote:
      "{names} can't reach that threshold, so saving takes it off them. It keeps the {was} alert, on its own. | {names} can't reach that threshold, so saving takes it off them. They keep the {was} alert, together.",
    applyToAllInstead: "Apply to 1 service instead | Apply to all {count} instead",
    saveForThisServiceOnly: "Save for this service only",
    repeatEveryValue: "repeats every {value} GB",
    batchResultCreated: "Created on {done} of {total} service | Created on {done} of {total} services",
    batchResultCreatedPool: "Created on {done} of {total} pool | Created on {done} of {total} pools",
    batchResultUpdated: "Updated on {done} of {total} service | Updated on {done} of {total} services",
    batchFinishedIn: "Finished in {seconds}s",
    batchStatusCreated: "Created",
    batchStatusUpdated: "Updated",
    batchStatusSkipped: "Skipped",
    batchStatusFailed: "Failed",
    batchWhySkipped: "Why {count} was skipped | Why {count} were skipped",
    batchWhyFailed: "Why {count} failed",
    batchFailedNoReason: "The request was rejected without a reason",
    batchReasonTitle: {
      at_capacity: "No room for another alert",
      no_email: "No recipient on file",
      duplicate: "Already has this alert",
      no_subscription: "No active subscription",
      over_limit: "Threshold above the plan limit",
      other: "Skipped",
    },
    batchReasonBody: {
      at_capacity:
        "These services already hold the most alerts they can. Some alerts are managed outside Compass and do not show here. Remove one to make room, then retry.",
      no_email: "No email given and the customer has no alert address set.",
      duplicate: "Same type, threshold and repeat already exists, so there is nothing to do.",
      no_subscription: "Kit is not currently subscribed, so it cannot hold an alert.",
      over_limit:
        "The threshold sits above what these plans allow, so the alert would never fire on them. Lower the threshold or run them separately.",
      other: "The API gave a reason this build has no copy for.",
    },
    batchFixCapacity: "Free up capacity",
    batchFixEmail: "Add a recipient",
    batchMoreTargets: "+{count} more",
    batchExportCsv: "Export result as CSV",
    batchFixAndRetry: "Fix the {count} and retry",
    batchViewInByAlert: "View in Alerts",
    csvService: "Service",
    csvKit: "Kit",
    csvAllKits: "ALL ({kits})",
    csvPlan: "Plan",
    csvAlertType: "Alert Type",
    csvStatus: "Status",
    csvReason: "Reason",
    appliesToServices: "Applies to {count} services",
    appliesTo: "Applies to",
    planIndependent: "plan-independent",
    justCreated: "just created",
    batchScopeNote:
      "This forms part of a {count}-service batch. Changing the threshold here leaves this service on its own. Use Alerts to change all {count}.",
    batchScopeNoteNoThreshold:
      "This forms part of a {count}-service batch. Saving here leaves this service on its own. Use Alerts to change all {count}.",
    noAlertServices: "1 service has no alert. | {count} services have no alert.",
    thirdSlotHelper: "Each service can hold up to {max} alerts.",
    createOneForThem: "Create one for them",
    groupKeepsOwnRecipient: "each service keeps its own",
    saveChangesOnServices: "Save Changes on 1 Service | Save Changes on {count} Services",
    saveChangesOnPools: "Save Changes on 1 Pool | Save Changes on {count} Pools",
    removeAlertTitle: "Remove this alert from {count} service? | Remove this alert from {count} services?",
    removeAlertTitlePools: "Remove this alert from {count} pool? | Remove this alert from {count} pools?",
    removeAlertBody:
      "Recipients stop getting this email for this service. Can't be undone, but you can recreate it with the same settings. | Recipients stop getting this email for all {count} services. Can't be undone, but you can recreate it with the same settings.",
    removeAlertBodyPools:
      "Recipients stop getting this email for this pool. Can't be undone, but you can recreate it with the same settings. | Recipients stop getting this email for all {count} pools. Can't be undone, but you can recreate it with the same settings.",
    removeFromServicesConfirm: "Remove from {count} service | Remove from {count} services",
    removeFromPoolsConfirm: "Remove from {count} pool | Remove from {count} pools",
    recipientsCount: "{count} recipient | {count} recipients",
    alertsAcrossServices: "{alerts} across {services}",
    alertsRefreshing: "Updating the list",
    alertScopeAnd: "{services} and {pools}",
    // the two halves of the lines above, so each one picks its own singular
    alertCountLabel: "1 alert | {count} alerts",
    serviceCountLabel: "1 service | {count} services",
    poolCountLabel: "1 pool | {count} pools",
    // the Alerts list sits under one header per type, and a header folds its alerts away
    collapseAlertType: "Collapse this type",
    expandAlertType: "Expand this type",
    addServicesToAlert: "Add services to this alert",
    addPoolsToAlert: "Add pools to this alert",
    groupScopeNote:
      "Saving changes this alert on the {count} service it sits on. To change that service on its own, open it in Services mode. | Saving changes this alert on all {count} services. To change some of them, tick those services on the right and use Edit selected.",
    groupScopeNotePools:
      "Saving changes this alert on the one pool it's on. | Saving changes this alert on all {count} pools. To change some of them, tick those pools on the right and use Edit selected.",
    editOnServices: "Edit on {count} services",
    removeFromServices: "Remove from 1 Service | Remove from {count} Services",
    removeFromPools: "Remove from 1 Pool | Remove from {count} Pools",
    servicesWithThisAlert: "Services with this alert",
    selectAllServices: "Select all services",
    selectAllPools: "Select all pools",
    servicesSelected: "{count} service selected | {count} services selected",
    poolsSelected: "{count} pool selected | {count} pools selected",
    editSelectedServices: "Edit selected",
    removeSelectedServices: "Remove selected",
    openInByService: "Open in Services",
    removeFromThisService: "Remove from this service",
    removeFromThisPool: "Remove from this pool",
    removeOneServiceTitle: "Remove this alert from {service}?",
    removeOneServiceBody:
      "The other service keeps it. Can't be undone, but you can add the service back to this alert. | The other {count} services keep it. Can't be undone, but you can add the service back to this alert.",
    removeOneServiceLast: "This is the last service on this alert, so the alert goes away with it.",
    removeOnePoolBody:
      "The other pool keeps it. Can't be undone, but you can add the pool back to this alert. | The other {count} pools keep it. Can't be undone, but you can add the pool back to this alert.",
    removeOnePoolLast: "This is the last pool on this alert, so the alert goes away with it.",
    sameThresholdDifferentRecipients: "same threshold, different recipients",
    sameThresholdDifferentRepeat: "same threshold, different repeat",
    sameThresholdDifferentRepeatAndRecipients: "same threshold, different repeat and recipients",
    alertMatchCount: "{count} of {total} alerts",
    noAlertMatch: 'No alert, service, kit or recipient matches "{query}".',
    clearSearch: "Clear search",
    serviceMatchesInByService: '1 service matches "{query}" in Services | {count} services match "{query}" in Services',
    switchToByService: "Switch to Services",
    addServicesTitle: "Add services to this alert",
    addServicesSubtitle: "They all get {alert}, with the same recipients and repeat.",
    addServicesConfigLocked: "The config is fixed here so the services join this alert. Edit the alert to change it.",
    addServicesSearch: "Find by Service or Kit",
    addServicesNone: "Every service already has this alert.",
    addServicesNoneForSearch: "Services matching that search already have this alert.",
    addServicesNoSearchMatch: 'No service or kit matches "{query}".',
    addServicesPlanTooSmall: "{plan} is smaller than the threshold",
    addServicesNoAllowance: "{plan} has no data allowance to measure",
    addServicesSubmit: "Add to {count} service | Add to {count} services",
    addPoolsTitle: "Add pools to this alert",
    addPoolsConfigLocked: "The config is fixed here so the pools join this alert. Edit the alert to change it.",
    addPoolsSearch: "Find by Pool",
    addPoolsNone: "Every other pool already has this alert.",
    addPoolsNoneForSearch: "Pools matching that search already have this alert.",
    addPoolsNoSearchMatch: 'No pool matches "{query}".',
    addPoolsSubmit: "Add to {count} pool | Add to {count} pools",
    alertsHeader: "Alerts",
    chooseAlertType: "Choose an Alert Type",
    addAlert: "Add Alert",
    alertsUsed: "{count}/{max} alerts used",
    atCapacityTitle: "At the {max} alert limit",
    atCapacityBody: "Remove one to add another. A bulk add will skip this service.",
    alsoOnOtherServices: "Also on {count} other service | Also on {count} other services",
    viewAlert: "View alert",
    sharedAlertEditWarning:
      "Saving changes this service only. The other service keeps the current alert. | Saving changes this service only. The other {count} services keep the current alert.",
    serviceListRange: "1-{count} of {total}",
    noServiceMatch: 'No service, kit or recipient matches "{query}".',
    noServices: "No services to show",
    pickService: "Pick one on the left to see its alerts.",
    noPoolMatch: 'No pool, kit or recipient matches "{query}".',
    noPoolsToShow: "No pools to show",
    pickPool: "Pick one on the left to see its alerts.",
    pool: "Pool",
    poolKitCount: "{count} kit on this pool | {count} kits on this pool",
    showMembers: "Show services",
    hideMembers: "Hide services",
    membersSelected: "{count} selected",
    selectPoolMembers: "Select the service on this pool | Select all {count} services on this pool",
    poolSharedNote:
      "An alert here covers the one kit on the pool. It uses the pool subscription, so it can't be alerted on its own. | An alert here covers all {count} kits on the pool. They share one subscription, so they can't be alerted one by one.",
    poolMemberBadge: "Pool member",
    poolMemberOf: "Part of {pool}",
    poolServiceList: "Service: {services} | Services: {services}",
    poolServiceListPartial:
      "Services: {services} and 1 kit with no service name | Services: {services} and {count} kits with no service name",
    poolServiceNamesMore: "{services} +{count} more",
    poolParentNote:
      "An alert here covers the whole pool. The kit on it can also hold alerts of its own. | An alert here covers the whole pool. The {count} kits on it can each hold alerts of their own.",
    poolUnlistedKits:
      "1 of these kits has no service of its own, so it isn't listed below. | {count} of these kits have no service of their own, so they aren't listed below.",
    batchSkipAtCapacity: "no room for another alert",
    batchSkipNoEmail: "no email address set and no customer alert email configured",
    batchSkipNoSubscription: "no active subscription",
    batchDeletePartial: "{count} alert could not be deleted | {count} alerts could not be deleted",
    noAlertGroups: "No alerts have been created yet",
    alertGroupServices: "Services",
    includedAlertRecipient: "Included recipients",
    lockedRecipientCoverage: "on {covered} of {total} services",
    customerAlertEmailLocked: "Always gets this alert. Set on your customer account, so it can't be removed here.",
    alertType: "Alert Type",
    sliderInfo: "The slider sets the alert's threshold",
    sliderInfoInput: "(the input as well)",
    sliderInfoEmpty_1: "This alert type does not need a threshold,",
    sliderInfoEmpty_2: "it gets triggered when the usage limit is reached",
    repeatInfo: "The alert will be triggered every {amount} GB after the threshold is reached",
    noActivationList: "Click on the “New Activation” button above to start.",
    addKit: "Add Kit",
    newActivation: "New Activation",
    activateKits: "Activate Kits",
    activations: "Starlink Activations",
    deleteActivationKit: "Are you sure you want to remove this kit from the activation list?",
    editKit: "Edit Kit",
    deleteKit: "Delete Kit",
    duplicateKit: "Duplicate Kit",
    activationForm: {
      detailsTitle: "Details",
      optInOutDescription: "Opt In for Priority Bandwidth Overage Usage",
      selectKitAndPlan: "Select first a Kit and Plan",
      createNewSite: "Create New Site",
      newSite: "New Site",
      kitEditedSuccessfully: "Kit edited successfully",
      kitAddedActivation: "Kit added to activation list",
      errorValidatingAddress: "Error while validating address, please try again or select an existing site",
      changeSite: "Existing Site",
      addressTitle: "Address",
      addressSubtitle: "Please provide the nearest physical address to where the kit will be operating",
      manualAddressSubtitle:
        "Please provide either an address or lat/lon where the kit will be operating. Not necessary for global plans",
      newSiteSubtitle: "Please provide the name for the new site",
      publicIp: "Public IP Address",
      contactSupport: "Contact Support",
      contactSupportMsg:
        "To activate a kit that isn't available in the kit dropdown please send the Starlink Activation form to <a href='mailto:starlink-activations{'@'}speedcast.com' style='text-decoration:underline; color: initial'>starlink-activations{'@'}speedcast.com</a>",
      manualActivation: "Request Manual Activation",
      manualActivationDesc:
        "If you would like to activate a kit or a plan that are not available in the self-service view you can request a manual activation by completing this form. This will be sent to the support staff for immediate activation.",
      manualActivationMissingData:
        "Some required information is unavailable in our system, preventing automatic activation. To proceed, complete this form to request a manual activation, which will be directed to the support staff for immediate attention.",
      additionalComments: "Additional Comments",
      successfullySubmitted: "Request successfully submitted",
      coordinatesTab: "Coordinates",
      addressTab: "Address",
      coordinatesPlaceholder: "Coordinate input will be available soon",
      coordinatesSubtitle: "Enter the coordinates where the kit will be operating",
      latLabel: "Lat",
      lonLabel: "Lon",
      coordinateHint: "Decimal degrees, e.g. Lat: 47.608013  Lon: -122.335167",
      latOutOfRange: "Latitude must be between -90 and 90",
      lonOutOfRange: "Longitude must be between -180 and 180",
      latInvalidNumber: "Enter a valid number",
      lonInvalidNumber: "Enter a valid number",
      addressOrCoordinatesHint: "Please enter either GPS coordinates or an address. Only one is required.",
      reverseGeocodeNoResults:
        "Could not find an address for the provided coordinates. Please verify the latitude and longitude.",
      reverseGeocodeCountryMismatch:
        "The coordinates resolve to {actual}, which does not match the selected operating country ({expected}). Please verify the coordinates or change the operating country.",
      addressCountryMismatch:
        "The validated address is in {actual}, which does not match the selected operating country ({expected}). Please verify the address or change the operating country.",
      addressSuggestionTitle: "Address Verification",
      addressSuggestionDesc:
        "We found a possible match for the address you entered. Please review the suggestion below.",
      yourAddress: "Your Address",
      suggestedAddress: "Suggested Address",
      useSuggestedAddress: "Use Suggested Address",
      editMyAddress: "Go Back and Edit",
      submitOriginalAddress: "Submit My Original Address",
      submitAnywayDisclaimer:
        "If the original address cannot be verified, the activation will be sent for manual review.",
      addressUnverifiedTitle: "Unable to Verify Address",
      addressUnverifiedDesc:
        "We were unable to verify the address you entered. Please check that it is valid. If the address is rejected once the activation request is submitted, it will be submitted for manual review and activation.",
      validationServiceError:
        "Unable to validate the address at this time. Please try again or use the Support button for manual activation.",
      verifyingAddress: "Verifying address...",
      addAnotherKit: "Add another kit",
      addToExistingSubscription: "Add to an existing subscription",
      secondKitId: "Second Kit Serial Number",
      dualSubscriptionHint: "This will activate 2 kits on the same subscription",
      existingSubscription: "Existing Subscription",
      existingSubscriptionHint: "This kit will be added to the selected kit's existing subscription",
      dualRequiresGlobal: "Dual subscriptions require Global region",
      kitDetailsTitle: "Kit Details",
      subscriptionTitle: "Subscription",
      dualKitSubscription: "Dual Kit Subscription",
      dualKitSubscriptionTooltip: "For plans that allow 2 active kits on one subscription.",
      secondKitTitle: "Second Kit",
      secondKitSubtitle: "Both kits run on one shared Starlink plan.",
      secondKitNewOption: "New kit",
      secondKitNewOptionDesc: "Activate a second kit on this new plan.",
      secondKitExistingOption: "Existing active kit",
      secondKitExistingOptionDesc: `Add kit to an existing subscription.`,
      existingSubscriptionJoinInfo: `The new kit will be added to {kitId}'s subscription - {planName}.`,
      existingSubscriptionInheritedInfo: `Operating country, Starlink plan and site are inherited from the selected kit's existing subscription.`,
      save: "Save",
    },
    activationStatus: {
      submitted: "Submitted",
      notSubmitted: "Not Submitted",
    },
    recentActivations: "Recent Activations",
    noRecentActivations: "No Recent Activations",
    checkingStatus: "Checking Status",
    statusCheckUnavailable: "Status Check Unavailable",
    kitDetails: "Kit Details",
    kitSerialNumber: "Kit Serial Number",
    userTerminalId: "User Terminal ID",
    dishSerialNumber: "Dish Serial Number",
    default: "Default",
    copy: "Copy",
    copied: "Copied",
    noData: "No Data",
    activatedDate: "Activated Date",
    deactivatedDate: "Deactivated Date",
    planDetails: "Plan Details",
    currentPlan: "Current Plan",
    currentKitName: "Current Kit Name",
    newKitName: "New Kit Name",
    renameKit: "Rename",
    renameKitConfirmation: "Enter a new name for this kit.",
    renameKitTimeMessage: "Kit names change across multiple systems and take 15-30 minutes to fully reflect.",
    changePlan: "Change Kit Plan",
    scheduledPlanChanges: "Scheduled Plan Changes",
    manualPlanChange: "Request Manual Plan Change",
    cancelScheduledPlanChange: "Cancel scheduled plan change",
    cancelScheduledDeactivation: "Cancel scheduled deactivation",
    scheduledForDeactivation: "Scheduled to deactivate on {deactivateAt}",
    manualPlanChangeDesc:
      "If you would like a plan that is not available in the self-service view you can request a manual plan change by completing this form. This will be sent to the support staff for immediate action.",
    none: "None",
    priorityOptIn: "Priority Opt In",
    viewTelemetry: "View Telemetry",
    optedIn: "Opted In",
    optedOut: "Opted Out",
    optIn: "Opt In",
    optOut: "Opt Out",
    optInDisclaimer:
      "Additional usage based charges will apply to traffic which exceeds the plan’s priority access threshold. By confirming you agree to additional charges from any overage data. This kit will remain opted in to priority overage data until you opt out.",
    optOutDisclaimer:
      "Data traffic in excess of the applicable priority access threshold will be throttled. By confirming you acknowledge you may experience slower throughput speeds.",
    optInLimitMessage: "Please note: Changes to a kit's data overage status can only be made once per 24 hour period.",
    planChangeLimitMessage: "Please note: Changes to a kit's plan can only be made once per 24 hour period.",
    renameKitLimitMessage: "Please note: Changes to a kit's name can only be made once per 24 hour period.",
    optInLocked: "Priority Data Change Lock",
    optInLockedMessage:
      "Priority data changes can only be made once per 24 hour period. Please try again 24 hours after the latest change.",
    optInLockedLatest: "Latest change: ",
    optInIneligible: "This kit is ineligible for opting in to overage priority data due to its plan.",
    optInIoT: "Opt in is not available on IoT plans.",
    optInPool: "Opt in/out is not available on pooled plans.",
    poolMember: "Member of a pooled plan",
    viewPool: "View Pool",
    planLocked: "Starlink Plan Change Lock",
    planLockedMessage:
      "Starlink plan changes can only be made once per 24 hour period. Please try again 24 hours after the latest change.",
    planChangeConfirmation: "Please confirm that you would like to change the plan of this kit.",
    planLockedLatest: "Latest change: ",
    statusLocked: "Kit Locked",
    statusLockedMessage:
      "This kit is locked. Service changes are unavailable until the lock is removed. Please contact support for assistance.",
    renameLocked: "Kit Rename Lock",
    renameLockedMessage:
      "Kit renames can only be made once per 24 hour period. Please try again 24 hours after the latest change.",
    renameLockedLatest: "Latest change: ",
    speedcastUser: "Speedcast User",
    speedcastChangeLock:
      "Speedcast users are unable to make service changes in Compass at this time. Please ensure the account has a customer admin and request that the customer log in to Compass and make the required changes so they can be logged.",
    reboot: "Reboot",
    rebootTitle: "Reboot Kit",
    rebootConfirmation: "Please confirm you want to reboot kit {kitId}.",
    rebootTimeMessage:
      "This will request a reboot from Starlink. It may take several minutes for Starlink to action the request. You will be notified when Starlink has accepted the request.",
    rebootCompleted: "Starlink accepted the reboot. The kit should be back online within a few minutes.",
    rebootFailed: "Could not reboot kit {kitId}",
    rebootTimedOut: "The reboot request for kit {kitId} timed out",
    deactivateTitle: "Deactivate Kit",
    deactivateConfirmation: "Please confirm that you would like to deactivate this kit.",
    futureDeactivateMessage: "Set Future Deactivation Date",
    deactivateTimeMessage:
      "Scheduled deactivations run at 23:00 UTC on the selected date. Today's UTC date is not available.",
    scheduledDeactivation: "Scheduled Deactivation",
    deactivateReason: "Reason for Deactivation",
    specifyReason: "Please Specify",
    ipVisibilityChange: "IP Visibility Change",
    recentChangesTitle: "Recent Changes",
    recentChanges30Days: "Recent Changes (30 days)",
    recentChangesTooltip: "For changes older than 30 days, visit the Activity History page linked at the top.",
    noRecentChanges: "No Recent Changes",
    recentChangesColumns: {
      name: "Name",
      username: "Username",
      action: "Action",
      date: "Date",
    },
    aboutAlerts: "About Starlink Alerts",
    historicalAlerts: "Historical Alerts",
    activeAlertsDesc:
      "Alerts will persist for as long as they are active and the kit continues to report telemetry data via the Starlink API. If a kit has stopped reporting data you can use the Alerts Timeline Widget to get a historical look at the last alerts that were being reported.",
    allAlertsInfo: "This is the current list of Starlink alerts that can be returned from Starlink.",
    alertStorageInfo:
      "Alerts are triggered if the condition was met at least once in the previous 15 seconds on the kit but may take several minutes to be passed to Speedcast. Speedcast stores these alerts and shows alerts active within the last 5 minute for kits that have been online and reporting data in that timeframe.",
    noAlertSelection: "No Alert Selected",
    noActiveAlerts: "There are currently no active alerts from Starlink",
    submittingKitsForActivation: "Submitting Kits for Activation",
    submittingKitsDesc:
      "Once accepted Compass will attempt to activate the requested kits with Starlink. This can take up to 15 minutes and progress can be monitored in the Recent Activations table.",
    forbiddenActivationError:
      "You do not have permissions to activate requested kits. Please contact your admin to verify your permissions.",
    confirmLeaveActivations:
      "The kits you have added have not been submitted for activation. Click the 'Activate Kits' button to submit them. If you leave your changes will not be saved.",
    ipAddresses: "IP Addresses",
    changeIpPolicy: "Change IP Policy",
    ipPolicy: "IP Policy",
    defaultIp: "Default IP",
    publicIp: "Public IP",
    publicIps: "Public IPs",
    ipPolicyDisclaimer:
      "After submitting the request it may take several minutes for the new IP Policy to take affect. The kit must be online for the change to be reflected in Compass.",
    starlinkIpPolicyDesc:
      'Starlink offers two IPv4 policies, "default" and "public". The default IPv4 configuration uses Carrier-Grade Network Address Translation (CGNAT) using private address space from the 100.64.0.0/10 prefix assigned to Starlink clients via DHCP. Network Address Translation (NAT) translates between private and Starlink public IPv4 Addresses. Starlink supports native IPv6 across all Starlink routers, kit versions, and service plans. All IPv6 compatible Starlink router clients are assigned IPv6 addresses.',
    starlinkPublicIpDesc:
      "The Starlink public IPv4 policy is an optional configuration available to Local and Global Priority customers. A public IPv4 is reachable from any device on the Internet and is assigned to Starlink network clients using DHCP. Although truly static IPs are not available, a reservation system retains the public IPv4 address and IPv6 prefix even when the system is off or rebooted. However, relocating the Starlink or software updates may change these addresses. Public IPv4 addresses are available to the Local and Global Priority service plans. The public IPv4 option can be enabled from the account dashboard, see instructions here. Note: Starlink WiFi routers do not support port forwarding or firewall rules for IPv4 or IPv6.",
    activationsFaq: {
      howLongActivation: {
        question: "How long does an activation take?",
        answer:
          "Depending on the status of the kit, an activation can take up to 15 minutes to complete but often takes only a few minutes. Users should see data passing immediately after the kit is activated but it may take several minutes to be reflected in Compass.",
      },
      cantFindKit: {
        question: "What do I do if I can't find my kit in the dropdown?",
        answer:
          "A kit must be tied to the specific account you are viewing in order to show in the activation menu. If the kit is on a different account you must use the company dropdown in the upper left corner to change the account. If you are unsure where the kit is you can",
        listItem1:
          "Contact your Speedcast account representative to request that they associate the kit with your account",
        listOr: "or",
        listItem2:
          "Submit a manual activation request by clicking the 'New Activation' button and then clicking the 'Support' button in the upper right corner",
      },
      planNotShowing: {
        question: "What do I do if my plan is not showing?",
        answer:
          "We are hard at work connecting our systems so that your quoted plans will be available for you to activate your kit on. Please reach out to your Speedcast account representative or the support team to request that your plan be added to your account. You can also submit a manual activation request using the 'Support' button in the 'New Activation' dialog box.",
      },
      errorDuringActivation: {
        question: "What happens if there is an error during the activation?",
        answer:
          "Compass will attempt to open a ticket with the support team on your behalf so that they can resolve the issue and complete the activation. If the ticket creation is successful you will receive a ticket number so that you can track the status of the request. If you do not receive a ticket number please contact support to complete your activation.",
      },
      manualActivation: {
        question: "What is a manual activation request?",
        answer:
          "A request will be sent to Speedcast's Starlink Activations team to manually process your activation. You will receive a ticket number so you can monitor the progress of your request.",
      },
      multipleKits: {
        question: "Can I activate multiple kits on one service line?",
        answer:
          "This feature is not available in Compass at this time. Please contact support using the Starlink activation form to request this type of activation.",
      },
      differentCountry: {
        question: "Why can't I select a different country for my quoted plan?",
        answer:
          "Plan pricing is unique to a location. If you would like to operate a kit in a location that isn't listed please contact your Speedcast representative to quote a plan for that location.",
      },
      latLongActivation: {
        question: "How do I activate on a local plan if I only have a latitude and longitude?",
        answerPart1: "You can submit an activation without an address by generating a",
        plusCodeLink: "plus code",
        answerPart2: "and entering it in the Address Line 1 field. Here's an example of a plus code:",
        exampleCode: "HJWG+JR",
      },
    },
    planChangeFaq: {
      whenCanChange: {
        question: "When can I change plans?",
        answer:
          "Plan upgrades will take place immediately. Downgrades and some other types of changes can only occur on the first day of the month. A downgrade requested after the 1st will be scheduled for the 1st of the next month.",
      },
      howLongChange: {
        question: "How long does a plan change take?",
        answer:
          "Depending on the status of the kit, a plan change can take up to 15 minutes to complete but often takes only a few minutes or less.",
      },
      planNotShowing: {
        question: "What do I do if my plan is not showing?",
        answer:
          "We are hard at work connecting our systems so that your quoted plans will be available for you to choose from. Please reach out to your Speedcast account representative or the support team to request that your plan be added to your account. You can also submit a manual plan change request using the 'Support' link in the 'Change Kit Plan' dialog box.",
      },
      errorDuringChange: {
        question: "What happens if there is an error during the plan change?",
        answer:
          "Compass will attempt to open a ticket with the support team on your behalf so that they can resolve the issue and complete the plan change. If the ticket creation is successful you will receive a ticket number so that you can track the status of the request. If you do not receive a ticket number please contact support to complete your plan change.",
      },
      deactivateReactivate: {
        question: "Why does the prompt say the kit needs to be deactivated and reactivated?",
        answer:
          "In some scenarios, such as changing between local and global plans or changing regions, it is required that the kit is deactivated and reactivated in order to change plan. It is not advised to do this in a low connectivity environment. Any public IP on the kit will be lost.",
      },
      manualChange: {
        question: "What is a manual plan change request?",
        answer:
          "A request will be sent to Speedcast's Starlink team to manually process your plan change. You will receive a ticket number so you can monitor the progress of your request.",
      },
      multipleKits: {
        question: "Can I change multiple kits' plans at a time?",
        answer:
          "This feature is not available in Compass at this time. Please contact support using the Starlink plan change form to request this.",
      },
    },
    dataBoosters: "Data Boosters",
    dataBoostersDesc: "Flexible on-demand data for your Starlink service",
    availableDataBoosters: "Available Data Boosters",
    dataBoosterQuantity: "Quantity",
    noDataBoosters: "No data boosters available for this plan",
    dataBoostersUnavailableTitle: "Data Boosters Unavailable",
    dataBoostersIoT: "Data Boosters are not available on IoT plans.",
    dataBoostersPool: "Data Boosters are not available on pooled plans.",
    dataBoostersConfirmation:
      "You have selected the Data Booster referenced here for purchase.  If you click to accept where indicated, this account will be invoiced next month at the charges set out in the applicable service order which are payable according to the service order terms. Data Boosters must be used in the month during which they are purchased, and do not carry over to the following month.",
    dataBoostersAccept: "Accept",
    selectedDataBooster: "Selected Data Booster",
    dataBoosterDisclaimer: "Data is available for use immediately. Usage limits may take up to 1 hour to update.",
    dataBoostersPermissionErrorTitle: "Insufficient Permissions",
    dataBoostersPermissionError:
      "You do not have the required permissions to complete this request. Please verify that your account has Admin or Service Changes access for the requested kit and company. If you believe this is an error, contact your account administrator.",
    dataBoostersRejectedTitle: "Request Error",
    dataBoostersRejected:
      "Your Data Booster request could not be processed. A support case has been created for further assistance.",
    dataBoostersRejectedTicket: "Case number:",
    dataBoostersSuccessTitle: "Success",
    dataBoostersSuccess:
      "Your Data Booster has been added successfully. Additional data is available for use immediately. Usage limits may take up to 1 hour to reflect in Compass.",
    dataBoostersInfo: {
      overview: "What are Starlink Data Boosters?",
      overviewDesc:
        "Starlink Data Boosters allow you to purchase on\u2011demand data top\u2011ups for your Starlink service, providing extra capacity within your current billing cycle.",
      keyFeatures: "Key Features",
      keyFeaturesList: [
        "On\u2011Demand Purchase: Buy anytime via the Compass Portal",
        "Non\u2011Recurring: One\u2011time purchases only \u2014 no automatic renewals",
        "No Scheduling Required: Purchase when you need it",
        "Flexible Options: Available in 50GB, 250GB, and 500GB increments",
      ],
      importantNotes: "Important Notes",
      importantNotesList: [
        "No Rollover: Unused data expires at the end of the billing cycle",
        "No Cancellations or Refunds: Once purchased, orders cannot be reversed",
        "Global Plans Only: Local plans are not available at launch",
        "Compass Only: Data Boosters can only be purchased via the Compass Portal",
        "Service Order Form (SOF): A signed SOF is required to enable Data Boosters.",
      ],
      closing:
        "Starlink Data Boosters give you the control to stay connected without long\u2011term commitments\u2014perfect for periods of higher\u2011than\u2011usual data demand.",
      contact:
        "If you have any questions, please contact your Speedcast representative or email servicedesk{'@'}speedcast.com.",
    },
    tour: {
      introTitle: "Starlink alerts",
      introLede:
        "Alerts watch how much data a service has used and email you when it crosses a threshold you set. Each service holds up to {max} alerts.",
      introBody:
        "Alerts sit on the subscription, not the kit, so one alert can cover a batch of services at once. Set one up on a single service, or select several and create the same alert on all of them.",
      introBodyWithPools:
        "Alerts sit on the subscription, not the kit, so the same alert can cover a pool or a batch of services at once. Set one up on a single service, or select several and create the same alert on all of them.",
      viewsTitle: "Ways in",
      viewsBody:
        "By Service lists your services and the alerts on each one. By Alert turns it around and lists the alerts, with the services each one covers.",
      viewsBodyWithPools:
        "By Service lists your services and the alerts on each one. By Pool does the same for your pooled subscriptions. By Alert turns it around and lists the alerts, with the services each one covers.",
      poolsTitle: "Pooled subscriptions",
      poolsBody:
        "A pool carries its own alerts, separate from the services on it. One alert on the pool watches what the whole pool has used and emails you when the pool crosses the threshold, so the same alert does not have to go on every service. Pools get the same {max} slots a service does.",
      searchTitle: "Search",
      searchBody: "Filter by service name, kit ID or email address. It applies to whichever view you are in.",
      batchTitle: "Alerts on many services",
      batchBody:
        "Select the services you want and create one alert across all of them. Compass says up front how many get skipped for already holding {max} alerts.",
      serviceListTitle: "Services",
      serviceListBody:
        "Each row shows the kits on the service, its plan, and how many of the {max} alert slots are used.",
      serviceListBodyWithPools:
        "Each row shows the kits on the service, its plan, and how many of the {max} alert slots are used. A pool shows how many kits it covers instead. Opening one either names the services on it or lists them as rows of their own.",
      serviceDetailTitle: "Service details",
      serviceDetailBody:
        "The header carries the plan's usage limit, its Opt In status for priority overage data, and the alerts the service is already holding. Existing alerts open below it for editing.",
      addAlertTitle: "Add an alert",
      addAlertBody:
        "Pick a type, then Add Alert. GB Consumed per Month counts what the service has used, and fires once it has reached the threshold data limit. % Data Remaining counts what is left on the plan, and fires when it drops to the threshold share you set. No Data Remaining fires when the plan is used up.",
      alertCardTitle: "Set the threshold",
      alertCardBody:
        "Drag the slider to set the threshold, add the email addresses to notify, then save. GB Consumed per Month also takes a typed value and can repeat, emailing you again every so many GB after the first one.",
      alertGroupsTitle: "By Alert",
      alertGroupsBody:
        "By Alert lists one row per alert instead of one per service. Each row carries the threshold and the addresses it emails, and opening one shows every service the alert is on.",
      alertGroupActionsTitle: "Edit or remove an alert",
      alertGroupActionsBody:
        "Edit or remove the alert from its card and the change lands on every service it covers. To keep it to a few, tick them in the list and use Edit selected or Remove selected. Editing a selection splits those services off onto an alert of their own, and each row has its own remove too.",
      replay: "Walkthrough",
      faqTitle: "FAQ",
      faqBody: "The FAQ covers the rules behind alerts.",
    },
  },
  activateKitsSplashTitle: "Starlink Management",
  activateKitsSplashText:
    "The following pages allow you to activate Kits, confirm or amend a Service Plan, Opt In or Opt Out of Additional Priority data, purchase Data Boosters of Additional Priority Data, and Pause, Resume or Deactivate a Service Plan. By using Compass, you are notifying Speedcast of the changes you require, and Speedcast will invoice you under the terms of your contract accordingly. Please ensure that the Personnel using Compass are authorized to make changes on behalf of your company and to send and receive notices in relation to the Services under the contract.",
  activateKits: "Activate Your Kits",
  kitAddressTooltip:
    "Please select the kit serial number before adding the address details. The address must be the kit location at the time of activation.",
  kitNameTooltip: `Speedcast recommends using the vessel name or site location as a unique identifier for each activated kit. Example: "Home-001", "Office-002".`,
  activateKitsColSiteName: "Site Name or Vessel",
  activateKitsColKitId: "Kit Serial Number",
  activateKitsColName: "Kit Name",
  activateKitsColPlan: "Starlink Plan",
  activateKitsColAddress: "Address",
  selectKitFirst: "Enter location address",
  addAddress: "Add Address",
  editAddress: "Edit Address",
  addressSet: "Address Set",
  enterAddressForKit: "Enter Address for Kit",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  addressLine3: "Address Line 3",
  city: "City",
  stateProvince: "State/Province",
  zipPostal: "Zip/Postal Code",
  country: "Country",
  operatingCountry: "Operating Country",
  clickingSubmit: "Clicking Submit will send address to Starlink for service capacity check.",
  submittingAddress: "Submitting address...",
  addressSubmittedAwaiting: "Address submitted, awaiting confirmation (~30 seconds)...",
  gettingAddressID: "Getting new address ID...",
  checkingStarlinkCapacity: "Checking Starlink Capacity...",
  errorAddingAddress: "Error adding address.",
  addressNotAccepted: "Address not accepted, correct address and try again.",
  noStarlinkCapacity: "Unfortunately there is no Starlink capacity at this location.",
  kitMustBeActivatedInCountry:
    "Kit must be activated in the country it's account is assigned to.  Contact Speedcast support to change kit's assigned account.",
  removeRow: "Remove Row",
  editKitName: "Edit Kit Name",
  maximum50Characters: "Maximum 50 characters",
  maximum100Characters: "Maximum 100 characters",
  pleaseMaximum50Characters: "Please use maximum 50 characters",
  scheduledPlanChangesMessage: "Requested downgrades will be executed at the beginning of the next month",
  pleaseMaximum100Characters: "Please use maximum 100 characters",
  priorityAccessData: "Priority Access Data",
  priorityAccessDataOptIn: `Opt-in:  Additional usage-based charges will apply to customer traffic which exceeds the service plan’s priority data usage limit.`,
  priorityAccessDataOptOut: `Opt-out:  Data traffic in excess of the plan priority data usage limit will be throttled.`,
  kitActivationSummary: "Kit Activation Summary",
  activateKitsSummaryColKitId: "Kit Id",
  activateKitsSummaryColSiteName: "Site/Vessel Name",
  activateKitsSummaryColName: "Kit Name",
  activateKitsSummaryColPlan: "Plan",
  activateKitsSummaryColOptIn: "Opt In",
  myPlansTitle: "My Plans",
  myStarlinkServices: "My Starlink Services",
  activityHistory: "Activity History",
  changelog: "Change Log",
  agree: "I agree to the activation ",
  submittingKitsActivation: "Submitting kits for activation",
  errorActivatingKits: "There was an error submitting the activation",
  errorActivatingTicket: "A ticket has been submitted. Case number:",
  errorActivateKitsSummary: "Unfortunately, there was an issue while activating your kit(s).",
  submittingActionTicket: "Submitting a ticket to support. Please wait.",
  errorActivateKitsContactInformation:
    "Please call +1-305-627-6010 (Option 2) and for assistance.  We are also available via WhatsApp at +51-952-066-452.",
  submittingIPVisibilityRequest: "Submitting the request...",
  errorIPVisibilityRequest: "Error submitting request.",
  confirmOptOut: "You are about to Opt Out of additional Priority data. Are you sure?",
  confirmOptIn: "You are about to Opt In for additional Priority data. Are you sure?",
  // Statistics
  latency: "Latency",
  uploadSpeed: "Upload Speed",
  uploadCIR: "Upload CIR",
  downloadSpeed: "Download Speed",
  downloadCIR: "Download CIR",
  logonState: "Logon State",
  CNremote: "CN Remote",
  // iDirect
  modemUptimeTooltip: "Uptime of the modem OS",
  // Newtec
  signalStrength: "Signal Strength",
  bandwidthUtilization: "Bandwidth Utilization",
  returnErrors: "Return Errors",
  // User
  firstName: "First Name",
  lastName: "Last Name",
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  updatePassword: "Update Password",
  passwordRequirements: "Password Requirements",
  minimumEightCharacters: "Minimum 8 Characters",
  maximumFortyCharacters: "Maximum 40 Characters",
  atLeastOneLowerCaseLetter: "At least 1 lowercase letter",
  atLeastOneUppercaseLetter: "At least 1 uppercase letter",
  atLeastOneDigit: "At least 1 digit",
  passwordChanged: "Password Changed",
  setupMultiFactorAuthentication: "Setup Multi-Factor Authentication",
  light: "Light",
  dark: "Dark",
  selectACompany: "Select a Company",
  //My Account
  changePassword: "Change Password",
  profile: "Profile",
  uiTheme: "UI Theme",
  photo: "Photo",
  language: "Language",
  languageSelection: "Language Selection",
  startPage: "Start Page",
  dashboards: "Dashboards",
  ipsla: "IPSLA",
  uhp: "UHP",
  // Dashboard Page
  dashboardPage: {
    heading: "My Dashboards",
    newBtn: "New Dashboard",
    searchPlaceholder: "Search dashboards...",
    dashboardCount: "{count} dashboards",
    selectedCount: "{count} selected",
    noSearchResults: "No dashboards match your search.",
    titlePlaceholder: "Dashboard Title",
    titleRequired: "Title is required",
    titleAlreadyExists: "A dashboard with this title already exists.",
    createdLabel: "Created:",
    updatedLabel: "Updated:",
    edit: "Edit",
    delete: "Delete",
    deleteSelected: "Delete selected",
    cancel: "Cancel",
    save: "Save",
    layoutSaved: "Layout saved",
    editHeading: "Edit Dashboard",
    viewHeading: "View Dashboard",
    loadError: "Could not load dashboard.",
    empty: "No dashboards yet. Click New Dashboard to get started.",
    emptyReadonly: "No widgets on this dashboard",
    deleteTitle: "Delete Dashboard",
    deleteConfirm: 'Are you sure you want to delete "{title}"?',
    deleteSelectedTitle: "Delete Dashboards",
    deleteSelectedConfirm: "Are you sure you want to delete {count} selected dashboards?",
    deleteError: "Could not delete dashboard",
    deleteSelectedError: "Could not delete selected dashboards",
    selectDashboard: "Select {title}",
    backToList: "Back to dashboards list",
    dragHint: "Drag widgets here",
    goToDashboard: "Edit",
    viewDashboard: "View",
    widgetCount: "{count} widgets",
    dateFilterBadge: "Date filter",
    createdByPlaceholder: "by —",
    reorderError: "Could not save dashboard order",
    customizeDashboards: "Customize dashboards",
    discardConfirm: "Discard your unsaved changes?",
    filterByDate: "Filter by date range",
    showWidgetList: "Show widget list",
    hideWidgetList: "Hide widget list",
    addWidget: "Add Widget",
    deviceTypeLabel: "Device Type",
    deviceLabel: "Device",
    widgetLabel: "Widget",
    widgetLoadError: "Could not load widget data",
    widgetDeviceUnavailable: "This device is no longer available",
    widgetListSection: "Widget list",
    optionsSection: "Options",
    showDateRangeSelector: "Show date range selector",
    showDashboardTitle: "Show dashboard title",
    showEditButton: "Show edit button",
    showExportButton: "Show export button",
    previewOnlyControl: "This button is shown for preview only.",
    collapseSidebar: "Collapse sidebar",
    expandSidebar: "Expand sidebar",
    instructionsTitle: "Dashboard Instructions",
    helpIntro:
      "Use this page to build a dashboard for the services you want to monitor. The left panel is where you choose widgets and save the dashboard. The main area is where you name it, choose a date range when needed, and arrange the widgets.",
    helpAddTitle: "Adding widgets",
    helpAddBody:
      "Start with Add Widget. Device Type narrows the choices to one type of equipment or service. Device is the specific service or device, and Widget is the chart or panel you want to add. You can search in each field. After you choose a device and widget, Add Widget places it on the dashboard. Widgets already added for that device are hidden from the list.",
    helpTitleDateTitle: "Title, header, and date range",
    helpTitleDateBody:
      "Use the Dashboard Title field at the top of the main area to name the dashboard. In Options, choose which header elements appear when viewing the dashboard: title, Edit button, Export button, and shared date range selector. In the builder preview, an unchecked title stays visible with a dotted outline, and Edit/Export buttons are preview only. When the date selector is shown, widgets that use dates follow the selected range. Leave it off for each widget's usual default time period.",
    helpListTitle: "Widget list",
    helpListBody:
      "The Widget list section keeps a compact list of added widgets. Open it to review what is on the dashboard, jump to a widget in the layout, or remove one without scrolling through the page.",
    helpLayoutTitle: "Arranging the layout",
    helpLayoutBody:
      "The main layout shows the widgets as they will appear on the dashboard. New widgets are placed in the next open space. Drag a widget to move it, use the bottom-right handle to resize it, and use the X on the widget to remove it.",
    helpSaveTitle: "Saving changes",
    helpSaveBody:
      "A title is required before saving. Save creates the dashboard or updates the current one. Delete is available only when editing an existing dashboard. If you try to leave with unsaved changes, Compass asks whether to discard them.",
  },
  // Tickets
  tickets: "Cases",
  ticketCase: "Case",
  created: "created",
  casesTitle: "Cases",
  searchCases: "Search Cases...",
  changeRequests: "Change Requests",
  supportGuide: "Support Guide",
  supportGuideDescription: "Access the Speedcast Global NOC - Customer Service Guide.",
  viewTicket: "View Cases",
  newTicket: "New case",
  errorCreatingNewCase: "Error creating new case.",
  addNewMessage: "Add new message",
  loadMore: "Load more",
  status: {
    resolved: "resolved",
    pending: "pending",
  },
  statusTitle: "Status",
  comments: "Comments",
  attachments: "Attachments",
  requestCreated: "Created",
  createdBy: "Created by",
  priorityTitle: "Priority",
  notSet: "Not Set",
  updated: "updated",
  ago: "ago",
  details: "Details",
  ticket: {
    create: {
      ticket: "Create case",
      description:
        "   Please provide the details of your request. A member of our team will respond at the earliest. (All fields are required).",
      submit: "Submitting case...",
    },
    status: {
      New: "New",
      "In Progress": "In Progress",
      "On Hold": "On Hold",
      "Service Restored": "Service Restored",
      Resolved: "Resolved",
      Open: "Open",
      Closed: "Closed",
      Cancelled: "Cancelled",
      "Awaiting Info": "Awaiting Info",
      "Not Set": "Not Set",
    },
    priority: {
      Normal: "Normal",
      Moderate: "Moderate",
      High: "High",
      Critical: "Critical",
      "Not Set": "Not Set",
    },
    company: {
      label: "Company",
    },
    email: {
      label: "Email Address",
      hint: "The email that will receive notifications",
    },
    site: {
      label: "Site affected (Optional)",
      required: "Site must be selected.",
    },
    subject: {
      label: "How can we help you?",
      hint: "Brief summary of the issue",
      required: "Subject must be filled in.",
    },
    description: {
      label: "Description",
      hint: "Detailed account of the issue...",
      required: "Description must be filled in.",
    },
    submitText: "Submit",
    backToList: "Back to Case list",
    comments: {
      textOnlyHint: "Comments here are text only. To add files, reply to the case email with your attachments.",
      filePasteBlocked:
        "File uploads aren't supported here. Please reply to the case email with your attachments instead.",
    },
  },
  changeRequest: {
    create: {
      changeRequest: "Create change request",
      description:
        "   Please provide the details of your request. A member of our team will respond at the earliest. (All fields are required).",
      submit: "Submitting change request...",
    },
    status: {
      Review: "Review",
      Implement: "Implement",
      Scheduled: "Scheduled",
      Authorize: "Authorize",
      Assess: "Assess",
      New: "New",
      Closed: "Closed",
      Cancelled: "Cancelled",
      Canceled: "Cancelled",
    },
    company: {
      label: "Company",
    },
    email: {
      label: "Email Address",
      hint: "The email that will receive notifications",
    },
    site: {
      label: "Site affected",
      required: "Site must be selected.",
    },
    subject: {
      label: "How can we help you?",
      hint: "Brief summary of the issue",
      required: "Subject must be filled in.",
    },
    description: {
      label: "Description",
      hint: "Detailed account of the issue...",
      required: "Description must be filled in.",
    },
    submitText: "Submit",
    backToList: "Back to change request list",
  },
  // ACU
  Azimuth: "Azimuth",
  "Azimuth (Rel.)": "Azimuth (Rel.)",
  Elevation: "Elevation",
  Heading: "Heading",
  blockageStatus: "Blockage Status",
  blockedStatus: "Blocked",
  clearStatus: "Clear",
  valueACU: "Value",

  select: "Select",
  submit: "Submit",
  submitting: "Submitting...",
  fileSizeError: "Files must be less than 10MB",
  optional: "optional",
  showGraphs: "Show Graphs",
  hideGraphs: "Hide Graphs",
  selectService: "Select a Service",
  selectDevice: "Select a Device",
  showingResultsAcross: "Showing results across {n} services",
  showingResultsAcrossOne: "Showing results across 1 service",
  export: "Export",
  download: "Download",
  upload: "Upload",
  name: "Name",
  totalUsage: "Total Usage",
  percentage: "Percentage",
  availability: "Availability",
  Memory: "Memory",
  cpu: "CPU",
  jitter: "Jitter",
  packetLoss: "Packet Loss",
  throughput: "Throughput",
  responseTime: "Response Time",
  percentLoss: "Percent Loss",
  noData: "No Data Available",
  router: "Router",
  switch: "Switch",
  acu: "ACU",
  ipInterface: "IP Interface",
  wanAccelerator: "WAN Accelerator",
  send: "Send",
  expandMap: "Expand Map",
  locationInfo: "Location Info",
  locationAccuracy: {
    starlink:
      "The location data provided by Starlink is approximate and is displayed for informational purposes. It should not be relied upon for fixed site address or accurate vessel location.",
    "starlink-detail":
      'Starlink uses a geospatial hexagonal grid with limited resolution to track kits. The kit’s location is communicated by the ID of a hexagon on the grid, whose center is calculated and shown on the map. See the <a href="https://h3geo.org/docs/" target="_blank" rel="noopener noreferrer">introduction</a> for how H3 indexing works, and <a href="https://h3geo.org/docs/library/index/cell/" target="_blank" rel="noopener noreferrer">cell mode</a> for details on individual H3 cells.<br><br> Each cell is colour-filled as a heat map where the color gradients indicate relative amount of time spent in the cell: <span style="color:#00c600; font-weight:700">green</span> means less time in the cell, <span style="color:#ffc800;font-weight:700">yellow</span> gradients indicate more time, and <span style="color:#ff0000;font-weight:700">red</span> shows the most time spent relative to the other points on the map. The outlined cell shows the kit’s most recent reported location.',
    idirect:
      "The location displayed is the last communicated GPS coordinates reported by the modem, with the most recent position highlighted in yellow. Location data may be delayed or missing.",
    newtec:
      "The location displayed is from GPS coordinates reported by the modem for the selected time period, with the most recent position highlighted in yellow. Location data may be missing if the modem is not reporting or if reporting has been turned off.",
    oneweb:
      "The location displayed is from GPS coordinates reported by the OneWeb terminal for the selected time period, with the most recent position highlighted in yellow. Location data may be delayed or unavailable if the terminal is not reporting.",
    uhp: "Location data is provided by the UHP NMS using the UHP API, and the most recent position is highlighted in yellow. Data may be missing or delayed if there are communication issues with the NMS.",
    acu: "Location is provided by the antenna controller (ACU) and may be delayed or unavailable.",
  },
  errorMessages: {
    genericShort: "Something went wrong",
    genericLong: "Something went wrong and we were unable to get the requested data",
    genericTryAgain: "Something went wrong and we were unable to get the requested data, please try again later",
    noData: "No Data Available",
    noDataSearch: "No data found for '{q}'",
    noUsageData: "No Usage Data Available",
    noDataExplanation: "There is no telemetry data available for this modem",
    contact: "If the error persists, please contact the service desk",
    code: "Error code",
    noStarlinkKitsData: "No Starlink kits available for activation. Click support to request a manual activation.",
    noPricePlansData: "No Starlink plans available. Click support to request a manual activation.",
  },
  starlinkNoDataInfo: {
    invalidSerial: "The kit serial number contains unexpected characters. Please contact support.",
    deactivated: "This kit is currently deactivated and will not report usage data.",
    disabled: "This kit is currently disabled by Starlink. {alert}",
    noUsage:
      "Starlink is not reporting any usage data. Ensure the kit is activated and online. Data may take up to 6 hours to appear after activation.",
    noTelemetry:
      "No telemetry for the specified time period. Ensure the kit is online with a clear view of the sky. Use the date picker to inspect other data.",
  },
  errorAction: {
    loadingServices: "loading services",
    loadingUsers: "loading users",
  },
  rolesEditUserPermissions: "{company} Permissions",
  rolesEditAlerts: "Edit Alerts",
  rolesEmailAddress: "Email Address",
  rolesAddNewUser: "Add new user",
  rolesSuccessful: "The changes were submitted successfully",
  rolesError: "Something went wrong and we were unable to change the roles",
  availability_graph_title: "Availability",
  availability_table_title: "Outages",
  availability_error: "Something went wrong and we were unable to retrieve the availability.",
  outages: "Outages",
  lastMonth: "Last Month",
  thisMonth: "This Month",
  timestamp: "Timestamp",
  role: "Role",
  action: "Action",
  account: "Account",
  period: "Period",
  // OFFICIAL STARLINK TELEMETRY ALERTS - DO NOT EDIT UNLESS STARLINK UPDATES THEIR ALERT CODES
  starlinkAlerts: {
    activeAlerts: "Active Alerts",
    actuator_motor_stuck: {
      label: "Actuator Motor Stuck",
      short: "Motor Stuck",
      description: "The Starlink actuator motor is stuck",
      detail:
        "For actuated Starlink devices, the actuator motor is jammed and is not able to align the Starlink antenna to the desired angle. This can cause reduced performance, or the Starlink may not be able to connect to the network if the tilt too far from nominal.",
    },
    data_overage_rate_limited: {
      label: "Data Overage Rate Limited",
      short: "Rate Limited",
      description: "Starlink is rate limited as it is out of priority data",
      detail:
        "Starlink is rate limited as it is out of priority data. Add more by topping up or enabling automatic top-up.",
    },
    disabled_account_disabled: {
      label: "Disabled Account Disabled",
      short: "Account Disabled",
      description: "Service is disabled because the Starlink's account is disabled",
      detail:
        "The Starlink device will be disabled if the account it is on is also disabled. Please log in to this account to get more information on the restriction.",
    },
    disabled_blocked_country: {
      label: "Disabled Blocked Country",
      short: "Blocked Country",
      description: "Service is disabled because the Starlink is in a restricted service country",
      detail:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink is coverage is enabled, upgrade to a Mobile Global or Mobile Priority Service plan. Or opt-in for Mobile Priority Data.",
    },
    disabled_cell_is_disabled: {
      label: "Disabled Cell Is Disabled",
      short: "Cell Disabled",
      description: "Service is disabled because the Starlink is in a cell that will not get beams",
      detail:
        "The Starlink device has moved to a cell that Starlink does not serve. The current cell will not get beams for service.",
    },
    disabled_data_usage_exceeded_quota: {
      label: "Disabled Data Usage Exceeded Quota",
      short: "Quota Exceeded",
      description: "Service is disabled because the Starlink has exceeded the data usage quota",
      detail:
        "The Starlink device has been disabled as data usage has exceeded the data quota. If Starlink coverage is enabled, upgrade your plan to a higher quota.",
    },
    disabled_invalid_country: {
      label: "Disabled Invalid Country",
      short: "Invalid Country",
      description: "Service is disabled because the Starlink is in an unsupported country",
      detail:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink coverage is enabled, opt-in for Mobile Priority Data or upgrade to a Mobile Global or Mobile Priority Service plan.",
    },
    disabled_moving_too_fast: {
      label: "Disabled - Moving too Fast",
      short: "Moving Too Fast",
      description: "Service is disabled because the Starlink is moving too fast without an aviation service plan",
      detail:
        "The Starlink device is moving faster than the configured policy allows and service has been disabled. Update the service plan to one which supports higher speeds.",
    },
    disabled_moving_while_not_mobile: {
      label: "Disabled - Moving while not Mobile",
      short: "Moving (Not Mobile)",
      description: "Service is disabled because the Starlink is moving without a mobile service",
      detail:
        "The Starlink device is moving at greater than 10 MPH (4.4. meters per second) and service has been disabled. Update the service plan to a Mobile Priority service plan. Or opt-in for Mobile Priority Data.",
    },
    disabled_no_active_account: {
      label: "Disabled - No Active Account",
      short: "No Active Account",
      description: "Service is disabled because the account or associated service line is not active",
      detail:
        "The account associated with the Starlink device is not active or has been disabled. Check that the account is active and in good standing. Ensure that payment details are setup and no outstanding unpaid invoices have caused the service to be disabled.",
    },
    disabled_no_active_service_line: {
      label: "Disabled - No Active Service Line",
      short: "No Service Line",
      description: "Service is disabled because the account or associated service line is not active",
      detail:
        "The service line associated with the Starlink device is not active or has been cancelled. Check that the service line is active and the account is in good standing. Ensure that payment details are setup and no outstanding unpaid invoices have caused the service to be disabled.",
    },
    disabled_no_service_in_ocean: {
      label: "Disabled - No Service in Ocean",
      short: "No Ocean Service",
      description: "Service is disabled because the Starlink is in the ocean without a service that supports maritime",
      detail:
        "The Starlink device has moved into ocean coverage and does not have mobile priority data available. Update service plans to a Mobile Priority plan with additional data, or opt-in for Mobile Priority Data if you are on a mobile plan and have exceeded the Mobile Priority Data limit.",
    },
    disabled_roam_restricted: {
      label: "Disabled Roam Restricted",
      short: "Roam Restricted",
      description: "Service is disabled because the Starlink has roamed for too long outside of its home country",
      detail:
        "The Starlink device is being georestricted after roaming for too long in a country that is not the roaming terminal's home country. Restriction is not imposed if the user is in their home country.",
    },
    disabled_too_far_from_service_address: {
      label: "Disabled - Too Far from Service Address",
      short: "Too Far From Address",
      description: "Service is disabled because the Starlink is too far from the service address",
      detail:
        "The Starlink device has moved too far from the service location on the account. Update the service address to resume service.",
    },
    disabled_unknown_location: {
      label: "Disabled Unknown Location",
      short: "Unknown Location",
      description: "Service is disabled because the Starlink cannot determine its location",
      detail: "The Starlink device cannot determine its location and cannot receive service.",
    },
    disabled_unlicensed_country: {
      label: "Disabled Unlicensed Country",
      short: "Unlicensed Country",
      description: "The Starlink device is in an unlicensed country and has been disabled.",
      detail:
        "The Starlink device is in an unlicensed country and has been disabled. The Starlink's policy prohibits being served in unlicensed countries.",
    },
    disabled_unsupported_country: {
      label: "Disabled - Unsupported Country",
      short: "Unsupported Country",
      description: "Service is disabled because the Starlink is in an unsupported country",
      detail:
        "The Starlink device has moved to a country where Starlink is either not enabled or the service plan is limited to a specific region. If Starlink is coverage is enabled, upgrade to a Mobile Global or Mobile Priority Service plan. Or opt-in for Mobile Priority Data.",
    },
    disabled_unsupported_version: {
      label: "Disabled Unsupported Version",
      short: "Unsupported Version",
      description: "The Starlink's software version is not supported",
      detail:
        "The Starlink's software version is unsupported. This can happen if the Starlink has been offline for a while. Please submit a ticket if the issue persists.",
    },
    ethernet_slow_100mbps: {
      label: "Ethernet Slow 100mbps",
      short: "Eth 100M",
      description: "Ethernet link speed is negotiated to 100 Mbps",
      detail:
        "The ethernet link has auto negotiated to 100 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.",
    },
    ethernet_slow_10mbps: {
      label: "Ethernet Slow 10mbps",
      short: "Eth 10M",
      description: "Ethernet link speed is negotiated to 10 Mbps",
      detail:
        "This alert indicates that the ethernet link has auto negotiated to 10 Mbps. The Starlink device should auto negotiate to 1000 Mbps. There may be a cable or connection issue. Make sure the client device port is configured to 1000 Mbps auto-negotiation.",
    },
    high_sky_obstruction: {
      label: "High Sky Obstruction",
      short: "Sky Obstruction",
      description: "The Starlink is detecting an obstruction in the field of view",
      detail:
        "The Starlink device detected a high percentage of the sky with available satellites is obstructed. The high sky percent obstruction alert is a leading indicator that the Starlink device is detecting potential obstructions. The alert does not track percent time the Starlink device was disconnected from the network. See high_time_obstruction for alert for tracking connection interruptions. This alert will be set if 0.50% of the Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    high_sky_obstruction_mobile: {
      label: "High Sky Obstruction (Mobile)",
      short: "Sky Obstruction (Mobile)",
      description: "The Starlink is detecting an obstruction in the field of view while moving",
      detail:
        "The Starlink device detected a high percentage of the sky with available satellites is obstructed. The high sky percent obstruction alert is a leading indicator that the Starlink device is detecting potential obstructions. The alert does not track percent time the Starlink device was disconnected from the network. See high_time_obstruction for alert for tracking connection interruptions. This alert will be set if 0.50% of the Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    high_time_obstruction: {
      label: "High Time Obstruction",
      short: "Time Obstruction",
      description: "The Starlink is detecting a frequent obstruction in the field of view",
      detail:
        "The Starlink device detected a high percentage of the time when the Starlink device was not able to make a connection to a satellite. The high time obstruction alert is an indicator of the time that Starlink was unable to successfully make a connection and the connection was dropped. This alert will be set if 0.27% of the time Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    high_time_obstruction_mobile: {
      label: "High Time Obstruction (Mobile)",
      short: "Time Obstruction (Mobile)",
      description: "The Starlink is detecting a frequent obstruction in the field of view while moving",
      detail:
        "The Starlink device detected a high percentage of the time when the Starlink device was not able to make a connection to a satellite. The high time obstruction alert is an indicator of the time that Starlink was unable to successfully make a connection and the connection was dropped. This alert will be set if 0.27% of the time Starlink field of view is obstructed. Check that the Starlink is in an unobstructed location in all directions.",
    },
    info: {
      trigger: "Alerts are triggered if the condition was met at least once the previous 15 seconds.",
      persist: "Alerts will persist for as long as they are active.",
      update: "Alerts will auto update.",
    },
    mast_not_vertical: {
      label: "Mast not Vertical",
      short: "Mast Not Vertical",
      description: "The Starlink is not installed with the mast within 30 degrees off vertical",
      detail:
        "For actuated Starlink devices, the Starlink alignment system is not able to align the Starlink antenna to the desired angle because the mast is greater than 30 degrees from vertical. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected.",
    },
    moving_while_not_mobile: {
      label: "Moving While Not Mobile",
      short: "Moving (Not Mobile)",
      description: "Service is disabled because the Starlink is moving without a mobile service",
      detail:
        "The Starlink device is moving at greater than 10 MPH (4.4. meters per second) and service has been disabled. Update the service plan to a Mobile Priority service plan. Or opt-in for Mobile Priority Data.",
    },
    noAlerts: "No Active Alerts",
    pop_change: {
      label: "PoP Change",
      short: "PoP Change",
      description:
        "Starlink point of presence (PoP) location changed. This may cause a short disconnect and IP address change",
      detail:
        "The Starlink point of presence (PoP) has changed and as a result the Starlink will have a new IP address assigned for that region.",
    },
    power_disconnect_detected: {
      label: "Power Disconnect Detected",
      short: "Power Disconnect",
      description: "The Starlink detected that the previous reboot was caused by a loss of power",
      detail: "The Starlink will report this alert when recovering from an unexpectedly power disconnect.",
    },
    power_supply_thermal_throttling: {
      label: "Power Supply Thermal Throttling",
      short: "PSU Thermal",
      description: "The power supply is signaling that it is very hot and close to shutting down",
      detail:
        "The power supply is exceeding it's upper safety thermal threshold. As a result, the Starlink is throttling itself to reduce its power draw and let the power brick cool down.",
    },
    software_update_reboot_pending: {
      label: "Software Update Reboot Pending",
      short: "Update Pending",
      description: "Starlink software update is pending and will reboot at 3 AM local time (+/- 30 minutes)",
      detail:
        "The Starlink device has downloaded a software update and is scheduled to reboot at 3 AM local time +/- 30 minutes. Local time is based on the current physical location of the Starlink hardware. After this alert is triggered, a manual reboot will also update the software if the scheduled time is inconvenient.",
    },
    thermal_shutdown: {
      label: "Thermal Shutdown",
      short: "Thermal Shutdown",
      description: "The Starlink has exceeded the max temperature thresholds - needs a reboot to recover",
      detail:
        "The Starlink device has reached the maximum temperature threshold and has stopped service to cool down. Service will resume when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celsius. In extreme cases the Starlink will reboot in order to recover. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources, e.g. near an exhaust vent.",
    },
    thermal_throttle: {
      label: "Thermal Throttle",
      short: "Thermal Throttle",
      description:
        "The Starlink has exceeded high temperature thresholds and will reduce performance to lower temperature",
      detail:
        "The Starlink device has reached a high temperature threshold and is throttling performance to cool down. Performance will improve when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celsius. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources e.g. near an exhaust vent.",
    },
    thermal_throttling: {
      label: "Thermal Throttling",
      short: "Thermal Throttling",
      description:
        "The Starlink has exceeded high temperature thresholds and will reduce performance to lower temperature",
      detail:
        "The Starlink device has reached a high temperature threshold and is throttling performance to cool down. Performance will improve when the Starlink device reaches a nominal operating temperature. Starlink devices are designed to operation nominally when the ambient temperature is below 50 degrees Celsius. Physically check that the Starlink device is installed in a location that is properly ventilated and not exposed to external heat sources e.g. near an exhaust vent.",
    },
    unable_to_align: {
      label: "Unable to Align",
      short: "Unable to Align",
      description: "Unable to align to desired tilt direction",
      detail:
        "The Starlink device is installed in a location that it's not able to align the antenna to the desired angle. This may cause poor performance, or the Starlink device may not be able to connect to the network unless corrected. If the Starlink device has an actuator motor, physically inspect the Starlink install to ensure that the motor is functioning correctly by stowing and un-stowing the Starlink from the Starlink mobile app. If the Starlink device is a Flat mount un-actuated model, check that the Starlink is securely attached to a horizontal surface.",
    },
  },
  today: "Today",
  yesterday: "Yesterday",
  last7days: "Last 7 Days",
  last30days: "Last 30 Days",
  home: {
    starlinkMsg:
      "The location data provided by Starlink and displayed on the map provides an approximate location and should not be relied upon for the purpose of fixed site address or vessel location.",
  },
  networkTools: {
    networkTools: "Network Tools",
    beamFootprints: "Beam Footprints",
    satellites: "Satellites",
    teleports: "Teleports",
  },
  map: {
    map3d: "Map 3D",
    map2d: "Map 2D",
    legend: {
      ok: "Ok",
      warning: "Warning",
      alarm: "Alarm",
      noStatus: "No Status",
    },
  },
  modemStatus: {
    outdatedExplanation: "data is more than 1 hour old",
  },
  userPermission: {
    addNewUser: "Add New User",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    contactRelationships: "Company Assignment (Optional)",
    grantedRoles: "Role Assignment (Optional)",
    contactRelationshipsNote:
      "By default, a user on a parent account has access to all child accounts. If you would like to limit a user’s access to specific companies, please select them.",
    grantedRolesNote:
      "By default, a user has basic permissions. If you would like to grant additional roles to a user, please select them.",
    deleteUser: {
      title: "Delete User",
      description: "Are you sure you want to delete this user?",
      confirm: "Delete",
      cancel: "Cancel",
      action: "This will delete the user and all associated attributes.",
      remove:
        "This will remove the user's access to this company. User may continue to have access to other companies in the organization. To view or delete the user entirely visit",
    },
    admin: {
      title: "Admin",
      action: "Make Admin",
      confirmAction: "This will grant the user full Admin access for all companies the user has access to.",
      noPermission: "You do not have permission to assign an Admin role to this user.",
      remove: "Remove Admin",
      accountsMismatch: "Account access mismatch",
      rolesFaq: {
        intro:
          "Compass provides a robust role-based permission system designed to help organizations manage user access to various features within the application. This system enables you to grant specific permissions to users while safeguarding sensitive functions, such as service changes that may have financial implications.",
        availableRolesTitle: "Available Roles",
        adminRole: {
          title: "Admin",
          description:
            "The Admin role grants full functionality within Compass. Admin users are considered the most trusted members of the organization and have access to all areas of the application.",
          comprehensiveAccess: "Comprehensive Access: Admins can navigate all parts of Compass without restrictions.",
          roleAssignment:
            "Role Assignment: They can assign roles to any user within the organization, including those in child accounts.",
          financialResponsibility:
            "Financial Responsibility: Admins are fully accountable for any service changes that may incur financial obligations.",
        },
        alertsRole: {
          title: "Alerts",
          description: "The alerts role allows users to create, edit and delete Starlink usage email alerts.",
          detailsText:
            "Users have access to 3 types of alerts to automatically send email notifications when a condition is triggered. Alerting is done on a per-kit basis so users with the alert role will be able to manage the alerting for a kit for all users on the account. Each kit can have up to 3 alerts with up to 3 emails per alert. Alert management is available in the 'Manage My Services' menu.",
        },
        serviceChangesRole: {
          title: "Service Changes",
          description:
            "Users with this role can make modifications to services offered by Speedcast, including actions that may result in additional charges.",
          priorityData:
            "Priority Data Usage: Opting in or out of priority data usage beyond the service plan's limits.",
          kitService:
            "Kit Service Management: Request activations, deactivations or plan changes of any kits in a user's account.",
        },
        supportRole: {
          title: "Support",
          description:
            "The Support role allows users to interact with Speedcast's ticketing system through Compass. There are two variations of this role:",
          fullAccess: "Support (Full Access): Users can view, open, and respond to tickets.",
          readOnly: "Support Read-Only: Users can view tickets but cannot open or update them.",
          noSupport:
            "No Support Role: Users without a support role cannot create, view, or update tickets; the Support menu will be hidden.",
        },
        managingPermissionsTitle: "Managing User Permissions",
        managingPermissionsText:
          "Admins can easily manage user permissions across different companies by selecting a user from the table or using the three-dot menu on the right side of the row. This streamlined process allows for quick adjustments to user access throughout the organization. If you need assistance adding or removing users from any or all companies, please contact your service manager at Speedcast.",
        additionalInfoTitle: "Additional Information",
        apiAccess:
          "API Access: Access to the Compass API is managed separately and is not influenced by these roles. For more information about Speedcast's API offerings, please reach out to your service manager.",
        futureRoles:
          "Future Role Additions: We plan to introduce additional roles over time. Stay updated by checking Compass for new feature sets as they become available.",
      },
    },
  },
  //popup messages
  popupPlanChange: {
    title: "Change the plan of your kit",
    description: "You are about to {action} your current plan.",
    detailFirstOfMonth: "Your changes will take effect immediately.",
    detailNotFirstOfMonth: "Your changes will take effect on the 1st of {month}.",
    reactivateDisclaimer:
      "This change requires the kit to be deactivated and reactivated. There will be a loss of connectivity.",
    ticketGeneratedDisclaimer: "A manual support ticket will be generated on your behalf.",
    detailInvalidChange: "Switching plan term lengths is not available in Compass.",
    desiredPlanMissing: "Don't see the plan you want? Please contact our support team for assistance.",
    disclaimer: "*Additional fees may apply",
    success: "Your plan was updated successfully",
    error: "Your plan was not updated",
    btn_accept: "Confirm selection",
    scheduled: "Downgrade successfully scheduled",
    submittedAt: "Scheduled at: ",
    deletePlanChangeRequestSuccess: "Successfully removed request for plan change",
    deletePlanChangeRequestError: "Could not remove request for plan change",
  },
  popupDeactivate: {
    title: "Set a future deactivation time for your kit",
    description: "You are about set a future deactivation time for your kit.",
    success: "Deactivation time was updated successfully",
    error: "Deactivation was not updated successfully",
    btn_accept: "Confirm selection",
    scheduled: "Deactivation successfully scheduled",
    submittedAt: "Scheduled at: ",
    deleteDeactivationRequestSuccess: "Successfully removed request for deactivation",
    deleteDeactivationRequestError: "Could not remove request for deactivation",
  },
  starlinkAlertsReport: {
    linkLabel: "Starlink alerts report",
    usageMenuLabel: "Starlink Usage",
    alertsMenuLabel: "Starlink Active Alerts",
    pageTitle: "Select a Report",
    title: "All Modem Alerts",
    modemsPerPage: "Modems per page",
    activeLabel: "Active",
    modemsColumnName: "Kit",
    businessServiceColumnName: "Service",
    serviceKitColumnName: "Service / Kit",
    noActiveAlerts: "There are no active alerts for the requested kits",
    recordCount: "1-{total} of {total}",
    viewAlertHistory: "View alert history",
    alertHistory: "Alert History",
    legend: {
      critical: "Critical",
      warning: "Warning",
      info: "Info",
      noAlert: "No alert",
    },
  },
  servicesOverviewComponent: {
    successSpeedToggle: "Preferred speed saved to preferences",
    errorSpeedToggle: "Error saving speed preference",
    usageReportSearchBox: "Find by Service or Kit",
  },
  changeRequestsComponent: {
    searchChangeRequests: "Find Request...",
  },
  userRoles: {
    faq: "FAQ",
    title: "User Roles",
    quickViewUserRoles: "Quick View User Roles",
    userPermissions: "User Permissions",
  },
  faq: "FAQ",
  monitorsFaq: "Starlink Monitors FAQ",
  monitorsFaqContent: {
    howManyAlerts: {
      question: "How many alerts can I set on a kit or a pool?",
      answer:
        "Users can create up to 3 alerts per kit and up to 3 per pool, and the alerts can be of any alert type. A pool alert watches the pool's own usage limit, so it is separate from the alerts on the kits under it. Use the Alerts tab to change or delete one alert across every kit or pool it is on.",
    },
    howManyEmails: {
      question: "How many email address can I add to one alert?",
      answer:
        "Up to 10 email addresses can be set on each alert. You can enter email addresses one at a time or enter a list of emails separated by a comma or semicolon. There is no limit for unique email address across your fleet.",
    },
    emailsVerified: {
      question: "Are the email addresses verified?",
      answer:
        "No, when configuring a new alert any valid email address will be accepted. Please double check the email address before submitting them to verify that they will be sent to the right recipient.",
    },
    alertsReset: {
      question: "When do the alerts reset?",
      answer:
        "Alerts reset at the beginning of the month. If an alert is set in the middle of the month it will begin sending notifications for any events that happen after the alert was created. For example, a kit that has already used all of its included data allowance will not trigger a 'No data remaining' alert until the next month.",
    },
    emailAddress: {
      question: "From what email address will the alert be sent?",
      answer:
        "The requested email addresses will receive email notifications from dontreply{'@'}speedcast.com. Please be sure to add the email to your contacts to ensure that the message is delivered.",
    },
    whyNoKit: {
      question: "Why don't I see my kit?",
      answer:
        "The kit needs to be activated and in good standing to allow alerts to be set. Please open a ticket with the support team if you need additional help.",
    },
  },
  adminBanners: {
    accountAdminRoleInfo1: "Your Admin manages your account.",
    accountAdminRoleInfo2: "Contact your Admin to change your user permissions.",
    learnMore: "Learn more about User Permissions.",
  },
  plan: "Plan",
  service: "Service",
  alert: "Alert",
  email: "Email",
  edit: "Edit",
  selectAll: "Select All",
  clear: "Clear",
  remove: "Remove",
  repeats: "Repeats",
  saveChanges: "Save Changes",
  reset: "Reset",
  one: "One",
  two: "Two",
  three: "Three",
  emailInvalid: "Invalid email {emails} | Invalid emails: {emails}",
  errorAlertContactInfo: "Please contact support if this issue persists",
  errorLoadingData: "There was an error loading data for this modem",
  pleaseTryAgain: "Please try again later or choose a different period with the date picker.",
  noGPSData: "No GPS Data Available",
  oneweb: {
    usage: "Service Plan Usage",
    usageTooltip:
      "Usage by this OneWeb service plan per day. Data in Compass is for monitoring purposes and not service affecting.",
    usageDisclaimer:
      "Data usage tracking is not immediate and may be delayed. Counting shown is for informational purposes only, final amounts in monthly invoices are accurate. Statistics may be missing or undercounted while telemetry is unavailable.",
    apiStatus: {
      linkLabel: "OneWeb API status",
      pageTitle: "OneWeb API status",
      pageDescription:
        "Check the current availability of the OneWeb APIs used by Speedcast to collect terminal data and review recently recorded API errors.",
      currentTitle: "Current status",
      currentDescription:
        "Status reflects the OneWeb usage and telemetry APIs used by Speedcast to collect terminal data.",
      historyTitle: "API Errors",
      historyDescription:
        "Errors reported by Speedcast’s data platform when trying to reach OneWeb’s usage or telemetry APIs. Does not account for successful responses with missing data.",
      operationalSummary: "All OneWeb API services are currently operational.",
      degradedSummary: "One or more OneWeb API services are degraded. Some terminal data may not be available.",
      outageSummary: "One or more OneWeb API services are currently experiencing an outage.",
      unknownSummary: "Current OneWeb API status is unavailable.",
      operational: "Operational",
      degraded: "Degraded",
      outage: "Outage",
      unknown: "Unknown",
      lastExtraction: "Last extraction: {relativeTime} ({time})",
      currentEmpty: "No current OneWeb API status is available.",
      historyEmpty: "No repeated OneWeb API error periods were recorded in the selected period.",
      loadError: "OneWeb API status could not be loaded.",
      retry: "Retry",
      errorTooltip: "API errors from {start} to {end}",
      errorLegend: "Repeated API error period",
      noErrorLegend: "No repeated API errors reported",
    },
    telemetry: {
      signal: "Signal",
      throughput: "Throughput",
      cnxTraffic: "CNX Traffic",
      managementTraffic: "Management Traffic",
      wanTraffic: "WAN Traffic",
    },
    deviceInfo: {
      sections: {
        terminal: "Terminal",
      },
      labels: {
        name: "Name",
        terminalId: "Terminal ID",
        manufacturer: "Manufacturer",
        model: "Model",
        serialNumber: "Serial number",
      },
    },
    telemetryInfo: {
      title: "OneWeb telemetry data",
      openLabel: "About OneWeb telemetry data",
      intro:
        "OneWeb performance monitoring data provides historical measurements for User Terminals and site connectivity products shown in Compass.",
      reporting: "OneWeb telemetry data is available for up to 60 days.",
      sections: {
        signal: {
          title: "Signal",
          description: "Signal information helps monitor terminal signal quality and assess connectivity performance.",
          items: {
            rsrp: {
              label: "RSRP",
              value: "Reference Signal Received Power, shown in dBW/m².",
            },
            rssi: {
              label: "RSSI",
              value: "Received Signal Strength Indicator, shown in dBm.",
            },
            sinr: {
              label: "SINR",
              value: "Signal-to-interference-plus-noise ratio, shown in dB.",
            },
            lag: {
              label: "Lag time",
              value: "Up to 60 minutes.",
            },
          },
        },
        throughput: {
          title: "Throughput",
          description:
            "Throughput data provides uplink and downlink measurements for site connectivity products and supports performance troubleshooting.",
          items: {
            up: {
              label: "Up",
              value: "Upload throughput, shown in Mbps.",
            },
            down: {
              label: "Down",
              value: "Download throughput, shown in Mbps.",
            },
            lag: {
              label: "Lag time",
              value: "Up to 45 minutes.",
            },
          },
        },
        traffic: {
          title: "Traffic",
          description:
            "Traffic data shows transmitted and received traffic for terminal network interfaces, including CNX, WAN, and management interfaces.",
          items: {
            cnx: {
              label: "CNX Rx / Tx",
              value: "Data transmission through the CNX port, shown in bps.",
            },
            management: {
              label: "Management Rx / Tx",
              value: "Traffic on the management APN, shown in bps.",
            },
            wan: {
              label: "WAN Rx / Tx",
              value: "Traffic on the User APN, shown in bps.",
            },
            lag: {
              label: "Lag time",
              value: "5–10 minutes.",
            },
          },
        },
        location: {
          title: "Location",
          description:
            "User Terminal Location History provides historical terminal positions and timestamps to support movement monitoring.",
          items: {
            coordinates: {
              label: "Coordinates",
              value: "Terminal latitude and longitude displayed on the Compass map.",
            },
            lag: {
              label: "Lag time",
              value: "Up to 5 minutes.",
            },
          },
        },
      },
    },
  },
  ongoingAlertLegend: "Bars in red indicate ongoing alerts",
  activityInfo: "Activity History Info",
  activityHistoryInfo:
    "Activity history shows a record of any service change actions on each of your Starlink kits. This log only shows actions taken within Compass by a Compass user. Requests sent to the Speedcast Network Operations Center will not be reflected in this log.",
  latitude: "Latitude",
  longitude: "Longitude",
  confirmLeave: "Are you sure you want to leave?",
  stayHere: "Stay Here",
  leave: "Leave",
  loading: "Loading...",
  errorSubmitting: "There was an error submitting your request",
  totalPoolUsage: "Total Pool Usage",
  currentPoolUsage: "Current Pool Usage",
  poolSize: "Pool Size",
  monthlyUsage: "Monthly Usage",
  allowancePeriod: "Allowance Period",
  poolUsage: "Pool Usage",
  total: "Total",
  totalUsed: "Total Used",
  remaining: "Remaining",
  monthlyBreakdown: "Monthly Usage Breakdown",
  estimatedMonthlyUsage: "Estimated Monthly Usage",
  noPools: "There are no pools available for this account. Please select a different company.",
  nextAllocation: "Next Allocation",
  startDate: "Start Date",
  endDate: "End Date",
  filters: "Filters",
  filter: "Filter",
  columns: "Columns",
  noResults: "No Results",
  statuses: "Statuses",
  status: "Status",
  plans: "Plans",
  activationStatus: "Activation Status",
  search: "Search",
  showTestUsers: "Show Test Users",
  onlineStatus: "Online Status",
  na: "N/A",
  // Versa
  versa: {
    model: "Model",
    serialNo: "Serial #",
    softwareVersion: "Software Version",
    ipAddress: "IP Address",
    pingStatus: "Ping Status",
    servicesStatus: "Services Status",
    syncStatus: "Sync Status",
    templateStatus: "Template Status",
    lastLinksStatus: "Last Links Status",
    lastLinksStatusTable: "Last Links Status Table",
    link: "Link",
    status: "Status",
    vrfsUsage: "VRFs Usage",
    latency: "Latency",
    noDataWithFiltersMessage: "No filters selected",
    noDataWithFiltersTooltip: "Select one or more items in the filter to display data",
    unableToGetDataMessage: "Unable to get data",
    unableToGetDataTooltip: "A problem occurred while retrieving data",
    appsUsage: "Applications Usage",
    appsUsageTable: "Applications Usage Table",
    goToPage: "Go to page",
    previousPage: "Previous page",
    nextPage: "Next page",
    application: "Application",
    urlCategoriesUsage: "URL Categories Usage",
    urlCategoriesUsageTable: "URL Categories Usage Table",
    urlReputationsUsage: "URL Reputations Usage",
    urlReputationsUsageTable: "URL Reputations Usage Table",
    urlUsage: "URL Usage",
    urlCategories: "Categories",
    urlReputations: "Reputations",
    totalWebTraffic: "Total web traffic",
    totalUsage: "Total usage",
    category: "Category",
    reputation: "Reputation",
    up: "Up",
    degraded: "Degraded",
    down: "Down",
    unknown: "Unknown",
    viewAllLinks: "View all link statuses",
    moreLinks: "+{count} more links",
    safe: "Safe",
    flaggedShare: "{pct}% flagged",
    safeHint:
      "Safe is the share of classified traffic rated Trustworthy or Low Risk. Flagged covers Moderate Risk and above. Both exclude Unrated traffic (no Versa classification), so this percentage is out of rated traffic only.",
    otherHint: "Combined usage from entries below 2% of the total.",
    otherHintWithTable:
      "Combined usage from entries below 2% of the total. Open the Table view for the full breakdown.",
    filterPaths: "Filter Paths",
    filterLinks: "Filter Links",
    filterVrfs: "Filter VRFs",
    ipAddress: "IP Address",
    usersUsage: "IP/Users Usage",
    usersUsageTable: "IP/Users Usage Table",
    overallStatus: "Overall Status",
    usage: "Usage",
    cpuUSage: "CPU Usage",
    memUsage: "Memory Usage",
    diskUsage: "Disk Usage",
    sessionsNumber: "Number of Sessions",
  },
};
